import React, { SVGProps, MouseEventHandler } from 'react';

export const CreateGroup: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0668945" width="28.0936" height="28" rx="14" fill="#7D4AC3" />
        <path
            d="M14.1122 13.9998C15.5662 13.9998 16.7449 12.825 16.7449 11.3759C16.7449 9.92672 15.5662 8.75195 14.1122 8.75195C12.6582 8.75195 11.4795 9.92672 11.4795 11.3759C11.4795 12.825 12.6582 13.9998 14.1122 13.9998Z"
            fill="white"
        />
        <path
            d="M18.1623 15.8221C16.9164 15.1535 15.5301 14.7863 14.1155 14.75C12.7035 14.7874 11.3199 15.1546 10.0762 15.8221C9.70687 16.011 9.39699 16.2979 9.18067 16.651C8.96435 17.0042 8.84997 17.41 8.85012 17.8237V18.1686C8.84913 18.31 8.87622 18.4502 8.92983 18.5812C8.98345 18.7121 9.06252 18.8312 9.1625 18.9315C9.26248 19.0319 9.3814 19.1115 9.51239 19.1658C9.64339 19.2202 9.78388 19.2482 9.92577 19.2482H18.3053C18.4472 19.2482 18.5876 19.2202 18.7186 19.1658C18.8496 19.1115 18.9686 19.0319 19.0685 18.9315C19.1685 18.8312 19.2476 18.7121 19.3012 18.5812C19.3548 18.4502 19.3819 18.31 19.3809 18.1686V17.8237C19.3818 17.4107 19.2685 17.0055 19.0536 16.6524C18.8386 16.2993 18.5303 16.012 18.1623 15.8221Z"
            fill="white"
        />
        <path
            d="M8.47278 12.5004C9.51135 12.5004 10.3533 11.6613 10.3533 10.6262C10.3533 9.59107 9.51135 8.75195 8.47278 8.75195C7.43421 8.75195 6.59229 9.59107 6.59229 10.6262C6.59229 11.6613 7.43421 12.5004 8.47278 12.5004Z"
            fill="white"
        />
        <path
            d="M19.756 12.5004C20.7946 12.5004 21.6365 11.6613 21.6365 10.6262C21.6365 9.59107 20.7946 8.75195 19.756 8.75195C18.7174 8.75195 17.8755 9.59107 17.8755 10.6262C17.8755 11.6613 18.7174 12.5004 19.756 12.5004Z"
            fill="white"
        />
        <path
            d="M22.33 13.6481C21.5526 13.1794 20.6658 12.9209 19.7575 12.8984C18.8491 12.9209 17.9624 13.1794 17.185 13.6481C17.0688 13.7188 16.9626 13.8045 16.869 13.903C16.825 13.948 16.7931 14.0033 16.7761 14.0638C16.7591 14.1243 16.7577 14.1881 16.7719 14.2493C16.7861 14.3105 16.8156 14.3672 16.8575 14.4141C16.8995 14.461 16.9526 14.4967 17.0119 14.5178C17.5281 14.6939 18.0309 14.9068 18.5163 15.155C18.9424 15.3778 19.3087 15.6991 19.5845 16.0921C19.6194 16.1411 19.6657 16.1809 19.7194 16.2083C19.7731 16.2357 19.8326 16.2499 19.8929 16.2496H22.3526C22.572 16.236 22.7775 16.1375 22.9251 15.975C23.0727 15.8125 23.1506 15.5989 23.1424 15.3799V15.14C23.1476 14.8426 23.0755 14.549 22.9331 14.2875C22.7908 14.0261 22.583 13.8059 22.33 13.6481Z"
            fill="white"
        />
        <path
            d="M9.72897 15.1543C10.2143 14.9059 10.7171 14.6929 11.2334 14.517C11.2927 14.4959 11.3458 14.4603 11.3878 14.4134C11.4297 14.3665 11.4592 14.3098 11.4734 14.2486C11.4876 14.1874 11.4862 14.1236 11.4692 14.0631C11.4523 14.0026 11.4203 13.9473 11.3763 13.9023C11.2827 13.8039 11.1764 13.7182 11.0604 13.6474C10.2829 13.1786 9.3962 12.9202 8.48784 12.8977C7.57949 12.9202 6.69275 13.1786 5.91532 13.6474C5.6612 13.8058 5.45272 14.0272 5.31031 14.2901C5.1679 14.5529 5.09644 14.8481 5.10295 15.1468V15.3867C5.09667 15.6044 5.17555 15.8161 5.32292 15.9769C5.47029 16.1378 5.67461 16.2353 5.89276 16.2488H8.35245C8.41275 16.2492 8.47225 16.235 8.52592 16.2076C8.5796 16.1802 8.62587 16.1404 8.66085 16.0914C8.93659 15.6984 9.30287 15.377 9.72897 15.1543Z"
            fill="white"
        />
    </svg>
);

export const OrangeCrossInCircle: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#EE731B" />
        <path d="M11.5716 6.42857L6.42871 11.5714" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.42871 6.42857L11.5716 11.5714" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const Cross: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='34' height='34' rx='17' fill='none' />
        <path d='M22 12L12 22' stroke='#BFBFBF' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12 12L22 22' stroke='#BFBFBF' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export const MuteBell: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => {
    return <svg width="15" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0261 17.5175H4.12204C3.85402 17.5285 3.58645 17.4866 3.33466 17.3941C3.08287 17.3015 2.85181 17.1602 2.6547 16.9783C2.45758 16.7963 2.2983 16.5773 2.18595 16.3337C2.07361 16.0901 2.01042 15.8268 2 15.5587C2.0159 14.7802 2.26245 14.024 2.70844 13.3857C3.44363 12.2171 3.78992 10.8457 3.69763 9.46813C3.69763 4.97397 5.78703 2.5 9.57405 2.5C13.3611 2.5 15.4505 4.97397 15.4505 9.47008C15.3582 10.8477 15.7045 12.2191 16.4397 13.3877C16.8853 14.0254 17.1318 14.7809 17.1481 15.5587C17.1377 15.8268 17.0745 16.0901 16.9622 16.3337C16.8498 16.5773 16.6905 16.7963 16.4934 16.9783C16.2963 17.1602 16.0652 17.3015 15.8134 17.3941C15.5617 17.4866 15.2941 17.5285 15.0261 17.5175ZM9.57405 3.80587C6.54117 3.80587 5.0035 5.71179 5.0035 9.47008C5.09389 11.0807 4.6853 12.6799 3.83344 14.0498C3.50828 14.4874 3.32424 15.0138 3.30587 15.5587C3.30587 16.0961 3.95881 16.2116 4.12204 16.2116H15.0261C15.188 16.2116 15.8422 16.0961 15.8422 15.5587C15.824 15.0136 15.64 14.487 15.3147 14.0491C14.4629 12.6795 14.0544 11.0804 14.1446 9.47008C14.1446 5.71179 12.6069 3.80587 9.57405 3.80587Z" fill="#321A50" stroke="#321A50" />
        <path d="M9.57723 20.5003C8.94514 20.4995 8.3392 20.248 7.89231 19.8009C7.44541 19.3539 7.19405 18.7479 7.19336 18.1158C7.19312 17.9668 7.20755 17.8181 7.23646 17.6718C7.25335 17.5878 7.28663 17.5078 7.33441 17.4366C7.38219 17.3654 7.44353 17.3043 7.51492 17.2568C7.58631 17.2093 7.66636 17.1763 7.7505 17.1598C7.83464 17.1432 7.92122 17.1434 8.00529 17.1603C8.08936 17.1771 8.16928 17.2104 8.24049 17.2582C8.3117 17.306 8.3728 17.3673 8.42031 17.4387C8.46781 17.5101 8.50079 17.5902 8.51736 17.6743C8.53392 17.7584 8.53376 17.845 8.51686 17.9291C8.5047 17.9906 8.4988 18.0531 8.49923 18.1158C8.4942 18.2605 8.51834 18.4046 8.57021 18.5397C8.62208 18.6748 8.70063 18.7981 8.80117 18.9022C8.90171 19.0063 9.02218 19.0891 9.1554 19.1457C9.28862 19.2022 9.43186 19.2313 9.57658 19.2313C9.7213 19.2313 9.86454 19.2022 9.99776 19.1457C10.131 19.0891 10.2514 19.0063 10.352 18.9022C10.4525 18.7981 10.5311 18.6748 10.5829 18.5397C10.6348 18.4046 10.659 18.2605 10.6539 18.1158C10.6544 18.0531 10.6485 17.9906 10.6363 17.9291C10.6194 17.845 10.6192 17.7584 10.6358 17.6743C10.6524 17.5902 10.6853 17.5101 10.7329 17.4387C10.7804 17.3673 10.8415 17.306 10.9127 17.2582C10.9839 17.2104 11.0638 17.1771 11.1479 17.1603C11.2319 17.1434 11.3185 17.1432 11.4027 17.1598C11.4868 17.1763 11.5668 17.2093 11.6382 17.2568C11.7096 17.3043 11.771 17.3654 11.8187 17.4366C11.8665 17.5078 11.8998 17.5878 11.9167 17.6718C11.9456 17.8181 11.96 17.9668 11.9598 18.1158C11.9591 18.7477 11.7079 19.3535 11.2613 19.8005C10.8147 20.2475 10.2091 20.4991 9.57723 20.5003Z" fill="#321A50" stroke="#321A50" strokeWidth="0.8" />
        <path d="M2.71125 3.02411L17.7288 17.6126" stroke="#E8E9ED" strokeWidth="5" strokeLinecap="round" />
        <path d="M2.71125 3.02508L17.7288 17.6135" stroke="#321A50" strokeWidth="2" strokeLinecap="round" />
    </svg>

}

export const NewChat: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2273 8.19353V11.2276C11.2273 11.529 11.1075 11.818 10.8944 12.0312C10.6813 12.2443 10.3923 12.364 10.0909 12.364H2.13636C1.83498 12.364 1.54594 12.2443 1.33283 12.0312C1.11972 11.818 1 11.529 1 11.2276V3.27308C1 2.9717 1.11972 2.68266 1.33283 2.46955C1.54594 2.25644 1.83498 2.13672 2.13636 2.13672H5.17045" stroke="#F86624" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.95415 2.13636C9.58174 1.50877 10.5993 1.50877 11.2269 2.13636V2.13636C11.8545 2.76396 11.8545 3.78149 11.2269 4.40909L8.1052 7.53076C7.19357 8.44239 5.95713 8.95454 4.66788 8.95454H4.40869V8.69535C4.40869 7.40611 4.92084 6.16967 5.83248 5.25803L8.95415 2.13636Z" stroke="#F86624" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const SmallOrangeNewGroup: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="7" height="8" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2273 8.19353V11.2276C11.2273 11.529 11.1075 11.818 10.8944 12.0312C10.6813 12.2443 10.3923 12.364 10.0909 12.364H2.13636C1.83498 12.364 1.54594 12.2443 1.33283 12.0312C1.11972 11.818 1 11.529 1 11.2276V3.27308C1 2.9717 1.11972 2.68266 1.33283 2.46955C1.54594 2.25644 1.83498 2.13672 2.13636 2.13672H5.17045" stroke="#F86624" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.95415 2.13636C9.58174 1.50877 10.5993 1.50877 11.2269 2.13636V2.13636C11.8545 2.76396 11.8545 3.78149 11.2269 4.40909L8.1052 7.53076C7.19357 8.44239 5.95713 8.95454 4.66788 8.95454H4.40869V8.69535C4.40869 7.40611 4.92084 6.16967 5.83248 5.25803L8.95415 2.13636Z" stroke="#F86624" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

interface ParticipantOptionsProps extends SVGProps<SVGSVGElement> {
    active?: boolean;
}

export const ParticipantOptions: React.FunctionComponent<ParticipantOptionsProps> = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill={props.active ? "#F3F3F3" : "transparetn"} />
        <path
            d="M4.5 14.25C3.90326 14.25 3.33097 14.0129 2.90901 13.591C2.48705 13.169 2.25 12.5967 2.25 12C2.25 11.4033 2.48705 10.831 2.90901 10.409C3.33097 9.98705 3.90326 9.75 4.5 9.75C5.09674 9.75 5.66903 9.98705 6.09099 10.409C6.51295 10.831 6.75 11.4033 6.75 12C6.75 12.5967 6.51295 13.169 6.09099 13.591C5.66903 14.0129 5.09674 14.25 4.5 14.25ZM12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12C9.75 11.4033 9.98705 10.831 10.409 10.409C10.831 9.98705 11.4033 9.75 12 9.75C12.5967 9.75 13.169 9.98705 13.591 10.409C14.0129 10.831 14.25 11.4033 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25ZM19.5 14.25C18.9033 14.25 18.331 14.0129 17.909 13.591C17.4871 13.169 17.25 12.5967 17.25 12C17.25 11.4033 17.4871 10.831 17.909 10.409C18.331 9.98705 18.9033 9.75 19.5 9.75C20.0967 9.75 20.669 9.98705 21.091 10.409C21.5129 10.831 21.75 11.4033 21.75 12C21.75 12.5967 21.5129 13.169 21.091 13.591C20.669 14.0129 20.0967 14.25 19.5 14.25Z"
            fill="#757575"
        />
        <path
            d="M4.5 14.25C3.90326 14.25 3.33097 14.0129 2.90901 13.591C2.48705 13.169 2.25 12.5967 2.25 12C2.25 11.4033 2.48705 10.831 2.90901 10.409C3.33097 9.98705 3.90326 9.75 4.5 9.75C5.09674 9.75 5.66903 9.98705 6.09099 10.409C6.51295 10.831 6.75 11.4033 6.75 12C6.75 12.5967 6.51295 13.169 6.09099 13.591C5.66903 14.0129 5.09674 14.25 4.5 14.25ZM12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12C9.75 11.4033 9.98705 10.831 10.409 10.409C10.831 9.98705 11.4033 9.75 12 9.75C12.5967 9.75 13.169 9.98705 13.591 10.409C14.0129 10.831 14.25 11.4033 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25ZM19.5 14.25C18.9033 14.25 18.331 14.0129 17.909 13.591C17.4871 13.169 17.25 12.5967 17.25 12C17.25 11.4033 17.4871 10.831 17.909 10.409C18.331 9.98705 18.9033 9.75 19.5 9.75C20.0967 9.75 20.669 9.98705 21.091 10.409C21.5129 10.831 21.75 11.4033 21.75 12C21.75 12.5967 21.5129 13.169 21.091 13.591C20.669 14.0129 20.0967 14.25 19.5 14.25Z"
            fill="#757575"
        />
    </svg>
)

export const SliderArrow: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1763_47211)">
            <circle cx="14" cy="12" r="10" fill="#777777" />
        </g>
        <path fillRule="evenodd" clipRule="evenodd" d="M18.1147 12.2155C18.1147 12.0198 18.035 11.8326 17.8938 11.697L13.218 7.20091C12.9317 6.92539 12.4762 6.93438 12.2008 7.22088C11.9255 7.50719 11.9343 7.96255 12.2208 8.2379L16.3574 12.2155L12.2208 16.1931C11.9345 16.4683 11.9255 16.9237 12.2008 17.2102C12.4762 17.4966 12.9317 17.5056 13.218 17.2301L17.8938 12.734C18.035 12.5984 18.1147 12.4112 18.1147 12.2155Z" fill="white" />
        <defs>
            <filter id="filter0_d_1763_47211" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.7375 0 0 0 0 0.7375 0 0 0 0 0.7375 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1763_47211" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1763_47211" result="shape" />
            </filter>
        </defs>
    </svg>
);

export const SmallOrangeSpinnyLoader: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="animate-spin"
        width="14"
        height="14"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="11" cy="11" r="9" stroke="#F86624" strokeOpacity="0.3" strokeWidth="4" />
        <path
            d="M20 11C20 15.9706 15.9705 20 11 20C7.81368 20 5.01412 18.3442 3.41479 15.8462"
            stroke="#F86624"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PurpleSpinnyLoader: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="animate-spin"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Loading">
            <circle cx="11" cy="11" r="9" stroke="#7D4AC3" strokeOpacity="0.3" strokeWidth="4" />
            <path
                d="M20 11C20 15.9706 15.9705 20 11 20C7.81368 20 5.01412 18.3442 3.41479 15.8462"
                stroke="#7D4AC3"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
)

export const WhiteSpinnyLoader: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <div className="btn btn-primary font-inter md:text-18.5 zm:text-17 md:font-medium zm:font-semibold rounded-lg w-full md:h-60px zm:h-49px bg-mytChatOrangeFaded">
        <svg
            className="animate-spin"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Loading">
                <circle id="Ellipse 1" cx="14.5" cy="14.5" r="11.5" stroke="white" strokeOpacity="0.3" strokeWidth="5" />
                <path
                    id="Ellipse 2"
                    d="M26 14.5C26 20.8513 20.8513 26 14.5 26C10.4287 26 6.85145 23.8843 4.80786 20.6923"
                    stroke="white"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    </div>
);

export const upload: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="43" height="39" viewBox="0 0 43 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.2609 9.28571H33.3343L29.913 5.57143H18.6957V9.28571H28.2678L31.6891 13H39.2609V35.2857H9.34783V18.5714H5.6087V35.2857C5.6087 37.3286 7.2913 39 9.34783 39H39.2609C41.3174 39 43 37.3286 43 35.2857V13C43 10.9571 41.3174 9.28571 39.2609 9.28571ZM14.9565 24.1429C14.9565 29.2686 19.1443 33.4286 24.3043 33.4286C29.4643 33.4286 33.6522 29.2686 33.6522 24.1429C33.6522 19.0171 29.4643 14.8571 24.3043 14.8571C19.1443 14.8571 14.9565 19.0171 14.9565 24.1429ZM24.3043 18.5714C27.3891 18.5714 29.913 21.0786 29.913 24.1429C29.913 27.2071 27.3891 29.7143 24.3043 29.7143C21.2196 29.7143 18.6957 27.2071 18.6957 24.1429C18.6957 21.0786 21.2196 18.5714 24.3043 18.5714ZM9.34783 9.28571H14.9565V5.57143H9.34783V0H5.6087V5.57143H0V9.28571H5.6087V14.8571H9.34783V9.28571Z" fill="#EE731B" />
    </svg>
)

export const CreateNewChatIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="cursor-pointer"
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.2273 8.19353V11.2276C11.2273 11.529 11.1075 11.818 10.8944 12.0312C10.6813 12.2443 10.3923 12.364 10.0909 12.364H2.13636C1.83498 12.364 1.54594 12.2443 1.33283 12.0312C1.11972 11.818 1 11.529 1 11.2276V3.27308C1 2.9717 1.11972 2.68266 1.33283 2.46955C1.54594 2.25644 1.83498 2.13672 2.13636 2.13672H5.17045"
            stroke="#F86624"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.95415 2.13636C9.58174 1.50877 10.5993 1.50877 11.2269 2.13636V2.13636C11.8545 2.76396 11.8545 3.78149 11.2269 4.40909L8.1052 7.53076C7.19357 8.44239 5.95713 8.95454 4.66788 8.95454H4.40869V8.69535C4.40869 7.40611 4.92084 6.16967 5.83248 5.25803L8.95415 2.13636Z"
            stroke="#F86624"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SearchIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
            stroke="#838383"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.4999 17.5L13.8749 13.875"
            stroke="#838383"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChevronDown: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5888_29440)">
            <path
                d="M1.15674 2.17798L4.4996 5.34989L7.84245 2.17798"
                stroke="#9F9F9F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_5888_29440">
                <rect width="9" height="5.69318" fill="white" transform="translate(0 0.79541)" />
            </clipPath>
        </defs>
    </svg>
)
export const ChevronRight: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 6L3 12L9 18"
            stroke="black"
            strokeOpacity="0.4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const MuteIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="cursor-pointer"
        width="20"
        height="16"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5787 15.8489H3.88626C3.64801 15.8587 3.41018 15.8214 3.18637 15.7392C2.96255 15.6569 2.75716 15.5313 2.58195 15.3696C2.40674 15.2079 2.26515 15.0132 2.16529 14.7966C2.06543 14.5801 2.00926 14.346 2 14.1077C2.01413 13.4158 2.23329 12.7435 2.62972 12.1762C3.28323 11.1374 3.59104 9.9184 3.50901 8.69389C3.50901 4.69909 5.36625 2.5 8.73249 2.5C12.0987 2.5 13.956 4.69909 13.956 8.69563C13.8739 9.92014 14.1818 11.1392 14.8353 12.178C15.2314 12.7448 15.4505 13.4164 15.465 14.1077C15.4557 14.346 15.3996 14.5801 15.2997 14.7966C15.1998 15.0132 15.0582 15.2079 14.883 15.3696C14.7078 15.5313 14.5024 15.6569 14.2786 15.7392C14.0548 15.8214 13.817 15.8587 13.5787 15.8489ZM8.73249 3.66077C6.03659 3.66077 4.66978 5.35492 4.66978 8.69563C4.75012 10.1273 4.38693 11.5488 3.62973 12.7665C3.34069 13.1555 3.1771 13.6234 3.16077 14.1077C3.16077 14.5854 3.74116 14.6881 3.88626 14.6881H13.5787C13.7227 14.6881 14.3042 14.5854 14.3042 14.1077C14.288 13.6232 14.1244 13.1551 13.8353 12.7659C13.0782 11.5484 12.715 10.1271 12.7952 8.69563C12.7952 5.35492 11.4284 3.66077 8.73249 3.66077Z"
            fill="#321A50"
            stroke="#321A50"
        />
        <path
            d="M8.73423 18.4999C8.17237 18.4991 7.63376 18.2755 7.23652 17.8782C6.83928 17.4808 6.61585 16.9422 6.61524 16.3803C6.61502 16.2478 6.62785 16.1156 6.65354 15.9856C6.66856 15.9109 6.69814 15.8399 6.74061 15.7766C6.78309 15.7133 6.83761 15.659 6.90107 15.6167C6.96453 15.5745 7.03568 15.5452 7.11047 15.5305C7.18526 15.5157 7.26222 15.5159 7.33695 15.5309C7.41168 15.5459 7.48272 15.5755 7.54602 15.618C7.60932 15.6604 7.66363 15.715 7.70585 15.7784C7.74808 15.8419 7.77739 15.913 7.79212 15.9878C7.80685 16.0626 7.8067 16.1396 7.79168 16.2143C7.78087 16.269 7.77562 16.3246 7.77601 16.3803C7.77154 16.5089 7.79299 16.637 7.8391 16.7571C7.88521 16.8772 7.95503 16.9868 8.0444 17.0793C8.13377 17.1719 8.24085 17.2454 8.35927 17.2957C8.47768 17.346 8.60501 17.3719 8.73365 17.3719C8.86229 17.3719 8.98962 17.346 9.10803 17.2957C9.22645 17.2454 9.33354 17.1719 9.4229 17.0793C9.51227 16.9868 9.58209 16.8772 9.6282 16.7571C9.67431 16.637 9.69577 16.5089 9.69129 16.3803C9.69168 16.3246 9.68643 16.269 9.67562 16.2143C9.6606 16.1396 9.66046 16.0626 9.67518 15.9878C9.68991 15.913 9.71922 15.8419 9.76145 15.7784C9.80367 15.715 9.85799 15.6604 9.92128 15.618C9.98458 15.5755 10.0556 15.5459 10.1304 15.5309C10.2051 15.5159 10.282 15.5157 10.3568 15.5305C10.4316 15.5452 10.5028 15.5745 10.5662 15.6167C10.6297 15.659 10.6842 15.7133 10.7267 15.7766C10.7692 15.8399 10.7987 15.9109 10.8138 15.9856C10.8395 16.1156 10.8523 16.2478 10.8521 16.3803C10.8515 16.942 10.6282 17.4805 10.2312 17.8778C9.83421 18.2751 9.29589 18.4988 8.73423 18.4999Z"
            fill="#321A50"
            stroke="#321A50"
            strokeWidth="0.8"
        />
        <path d="M2.63157 2.96585L15.9805 15.9334" stroke="white" strokeWidth="5" strokeLinecap="round" />
        <path d="M2.63157 2.96633L15.9805 15.9338" stroke="#321A50" strokeWidth="2" strokeLinecap="round" />
    </svg>
)
export const OnlineIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5" r="4.5" fill="#04A777" stroke="white" />
    </svg>
)
export const GroupPeopleIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0668945" width="28.0936" height="28" rx="14" fill="#7D4AC3" />
        <path
            d="M14.1122 13.9998C15.5662 13.9998 16.7449 12.825 16.7449 11.3759C16.7449 9.92672 15.5662 8.75195 14.1122 8.75195C12.6582 8.75195 11.4795 9.92672 11.4795 11.3759C11.4795 12.825 12.6582 13.9998 14.1122 13.9998Z"
            fill="white"
        />
        <path
            d="M18.1623 15.8221C16.9164 15.1535 15.5301 14.7863 14.1155 14.75C12.7035 14.7874 11.3199 15.1546 10.0762 15.8221C9.70687 16.011 9.39699 16.2979 9.18067 16.651C8.96435 17.0042 8.84997 17.41 8.85012 17.8237V18.1686C8.84913 18.31 8.87622 18.4502 8.92983 18.5812C8.98345 18.7121 9.06252 18.8312 9.1625 18.9315C9.26248 19.0319 9.3814 19.1115 9.51239 19.1658C9.64339 19.2202 9.78388 19.2482 9.92577 19.2482H18.3053C18.4472 19.2482 18.5876 19.2202 18.7186 19.1658C18.8496 19.1115 18.9686 19.0319 19.0685 18.9315C19.1685 18.8312 19.2476 18.7121 19.3012 18.5812C19.3548 18.4502 19.3819 18.31 19.3809 18.1686V17.8237C19.3818 17.4107 19.2685 17.0055 19.0536 16.6524C18.8386 16.2993 18.5303 16.012 18.1623 15.8221Z"
            fill="white"
        />
        <path
            d="M8.47278 12.5004C9.51135 12.5004 10.3533 11.6613 10.3533 10.6262C10.3533 9.59107 9.51135 8.75195 8.47278 8.75195C7.43421 8.75195 6.59229 9.59107 6.59229 10.6262C6.59229 11.6613 7.43421 12.5004 8.47278 12.5004Z"
            fill="white"
        />
        <path
            d="M19.756 12.5004C20.7946 12.5004 21.6365 11.6613 21.6365 10.6262C21.6365 9.59107 20.7946 8.75195 19.756 8.75195C18.7174 8.75195 17.8755 9.59107 17.8755 10.6262C17.8755 11.6613 18.7174 12.5004 19.756 12.5004Z"
            fill="white"
        />
        <path
            d="M22.33 13.6481C21.5526 13.1794 20.6658 12.9209 19.7575 12.8984C18.8491 12.9209 17.9624 13.1794 17.185 13.6481C17.0688 13.7188 16.9626 13.8045 16.869 13.903C16.825 13.948 16.7931 14.0033 16.7761 14.0638C16.7591 14.1243 16.7577 14.1881 16.7719 14.2493C16.7861 14.3105 16.8156 14.3672 16.8575 14.4141C16.8995 14.461 16.9526 14.4967 17.0119 14.5178C17.5281 14.6939 18.0309 14.9068 18.5163 15.155C18.9424 15.3778 19.3087 15.6991 19.5845 16.0921C19.6194 16.1411 19.6657 16.1809 19.7194 16.2083C19.7731 16.2357 19.8326 16.2499 19.8929 16.2496H22.3526C22.572 16.236 22.7775 16.1375 22.9251 15.975C23.0727 15.8125 23.1506 15.5989 23.1424 15.3799V15.14C23.1476 14.8426 23.0755 14.549 22.9331 14.2875C22.7908 14.0261 22.583 13.8059 22.33 13.6481Z"
            fill="white"
        />
        <path
            d="M9.72897 15.1543C10.2143 14.9059 10.7171 14.6929 11.2334 14.517C11.2927 14.4959 11.3458 14.4603 11.3878 14.4134C11.4297 14.3665 11.4592 14.3098 11.4734 14.2486C11.4876 14.1874 11.4862 14.1236 11.4692 14.0631C11.4523 14.0026 11.4203 13.9473 11.3763 13.9023C11.2827 13.8039 11.1764 13.7182 11.0604 13.6474C10.2829 13.1786 9.3962 12.9202 8.48784 12.8977C7.57949 12.9202 6.69275 13.1786 5.91532 13.6474C5.6612 13.8058 5.45272 14.0272 5.31031 14.2901C5.1679 14.5529 5.09644 14.8481 5.10295 15.1468V15.3867C5.09667 15.6044 5.17555 15.8161 5.32292 15.9769C5.47029 16.1378 5.67461 16.2353 5.89276 16.2488H8.35245C8.41275 16.2492 8.47225 16.235 8.52592 16.2076C8.5796 16.1802 8.62587 16.1404 8.66085 16.0914C8.93659 15.6984 9.30287 15.377 9.72897 15.1543Z"
            fill="white"
        />
    </svg>

)

interface CrossIconProps extends SVGProps<SVGSVGElement> {
    CrossStyle?: string;
}

export const CrossIcon: React.FunctionComponent<CrossIconProps> = (props) => (
    <div className={`flex items-end justify-end cursor-pointer ${props.CrossStyle}`}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 5.5L5.5 16.5" stroke="#BFBFBF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.5 5.5L16.5 16.5" stroke="#BFBFBF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </div>
)
export const ChevronLeft: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 11L6 6L1 1" stroke="#757575" strokeWidth="2" strokeLinecap="round" />
    </svg>
)
export const OrangeCloseIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#EE731B" />
        <path
            d="M11.5716 6.42857L6.42871 11.5714"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.42871 6.42857L11.5716 11.5714"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const RightNavIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1230_6390)">
            <circle cx="14" cy="12" r="10" fill="#777777" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1147 12.2155C18.1147 12.0198 18.035 11.8326 17.8938 11.697L13.218 7.20091C12.9317 6.92539 12.4762 6.93438 12.2008 7.22088C11.9255 7.50719 11.9343 7.96255 12.2208 8.2379L16.3574 12.2155L12.2208 16.1931C11.9345 16.4683 11.9255 16.9237 12.2008 17.2102C12.4762 17.4966 12.9317 17.5056 13.218 17.2301L17.8938 12.734C18.035 12.5984 18.1147 12.4112 18.1147 12.2155Z"
            fill="white"
        />
        <defs>
            <filter
                id="filter0_d_1230_6390"
                x="0"
                y="0"
                width="28"
                height="28"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.7375 0 0 0 0 0.7375 0 0 0 0 0.7375 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1230_6390" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1230_6390" result="shape" />
            </filter>
        </defs>
    </svg>
)
export const UploadPicIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="70" cy="70" r="70" fill="#FFF2E8" />
        <path
            d="M87.2609 58.2857H81.3343L77.913 54.5714H66.6957V58.2857H76.2678L79.6891 62H87.2609V84.2857H57.3478V67.5714H53.6087V84.2857C53.6087 86.3286 55.2913 88 57.3478 88H87.2609C89.3174 88 91 86.3286 91 84.2857V62C91 59.9571 89.3174 58.2857 87.2609 58.2857ZM62.9565 73.1429C62.9565 78.2686 67.1443 82.4286 72.3043 82.4286C77.4643 82.4286 81.6522 78.2686 81.6522 73.1429C81.6522 68.0171 77.4643 63.8571 72.3043 63.8571C67.1443 63.8571 62.9565 68.0171 62.9565 73.1429ZM72.3043 67.5714C75.3891 67.5714 77.913 70.0786 77.913 73.1429C77.913 76.2071 75.3891 78.7143 72.3043 78.7143C69.2196 78.7143 66.6957 76.2071 66.6957 73.1429C66.6957 70.0786 69.2196 67.5714 72.3043 67.5714ZM57.3478 58.2857H62.9565V54.5714H57.3478V49H53.6087V54.5714H48V58.2857H53.6087V63.8571H57.3478V58.2857Z"
            fill="#EE731B"
        />
    </svg>
)
export const OrangeSuccessIon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" fill="#EE731B" />
        <path
            d="M31.4267 14.9285L18.4624 27.8928L12.5695 22"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const MiddleBorder: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="1" height="55" viewBox="0 0 1 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1.42063L0.5 27.5" stroke="url(#paint0_linear_6167_4866)" strokeLinecap="square" />
        <path d="M0.5 53.5794L0.5 27.5" stroke="url(#paint1_linear_6167_4866)" strokeLinecap="square" />
        <defs>
            <linearGradient
                id="paint0_linear_6167_4866"
                x1="-0.5"
                y1="7.73016"
                x2="1.98628"
                y2="7.91487"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E5E5E5" stopOpacity="0.01" />
                <stop offset="1" stopColor="#B1B1B1" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_6167_4866"
                x1="1.5"
                y1="47.2698"
                x2="-0.986277"
                y2="47.0851"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E5E5E5" stopOpacity="0.01" />
                <stop offset="1" stopColor="#B1B1B1" />
            </linearGradient>
        </defs>
    </svg>
)
export const RepeatIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1222_4112)">
            <path
                d="M11.3333 0.666748L14 3.33341L11.3333 6.00008"
                stroke="#888888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 7.33325V5.99992C2 5.29267 2.28095 4.6144 2.78105 4.1143C3.28115 3.6142 3.95942 3.33325 4.66667 3.33325H14"
                stroke="#888888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.66667 15.3333L2 12.6667L4.66667 10"
                stroke="#888888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14 8.66675V10.0001C14 10.7073 13.719 11.3856 13.219 11.8857C12.7189 12.3858 12.0406 12.6667 11.3333 12.6667H2"
                stroke="#888888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_1222_4112">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const ClockIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1222_4107)">
            <path
                d="M8.00071 14.6666C11.6826 14.6666 14.6674 11.6818 14.6674 7.99992C14.6674 4.31802 11.6826 1.33325 8.00071 1.33325C4.31881 1.33325 1.33405 4.31802 1.33405 7.99992C1.33405 11.6818 4.31881 14.6666 8.00071 14.6666Z"
                stroke="#888888"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 4V8L10.6667 9.33333"
                stroke="#888888"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_1222_4107">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const HumanIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.79601 8.33131C11.8585 8.33131 12.796 0.998047 7.79601 0.998047C3.10851 0.99808 4.04601 8.33131 7.79601 8.33131ZM7.95073 2.55505C8.61723 2.55505 9.7357 2.66671 9.7357 4.33338C9.7357 7.66671 6.16548 7.66671 6.16548 4.33338C6.16548 2.66671 7.28392 2.55505 7.95073 2.55505ZM7.95576 9.33171C3.35739 9.33171 2.37607 11.8659 2.23645 13.3886L2.20001 15.3334H3.68489L3.7302 13.505C3.88461 11.8198 5.38932 10.9646 7.95579 10.9646C10.5225 10.9646 12.0276 11.8202 12.181 13.4931L12.2217 15.3334H13.7282L13.6746 13.3763C13.5361 11.8659 12.5546 9.33171 7.95576 9.33171Z"
            fill="#888888"
        />
    </svg>
)

export const QuoteIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z"
            fill="#F2E9FF"
            stroke="white"
            strokeWidth="3"
        />
        <path
            d="M30.25 27.5V20.625H26.4688C26.6063 18.6312 28.05 17.875 30.25 17.875V15.125C26.4688 15.125 23.375 17.1875 23.375 20.9688V27.5H30.25Z"
            fill="#9671C9"
        />
        <path
            d="M20.625 27.5V20.625H16.8438C16.9813 18.6312 18.425 17.875 20.625 17.875V15.125C16.8438 15.125 13.75 17.1875 13.75 20.9688V27.5H20.625Z"
            fill="#9671C9"
        />
    </svg>
)

export const FaceBookLogo: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23 11.5C23 5.14872 17.8513 0 11.5 0C5.14872 0 0 5.14872 0 11.5C0 17.24 4.20541 21.9976 9.70312 22.8603V14.8242H6.7832V11.5H9.70312V8.96641C9.70312 6.08422 11.42 4.49219 14.0468 4.49219C15.3051 4.49219 16.6211 4.7168 16.6211 4.7168V7.54688H15.171C13.7424 7.54688 13.2969 8.43332 13.2969 9.34276V11.5H16.4863L15.9765 14.8242H13.2969V22.8603C18.7946 21.9976 23 17.24 23 11.5Z"
            fill="#1877F2"
        />
        <path
            d="M15.9745 14.8242L16.4844 11.5H13.2949V9.34276C13.2949 8.43332 13.7404 7.54688 15.169 7.54688H16.6191V4.7168C16.6191 4.7168 15.3031 4.49219 14.0449 4.49219C11.418 4.49219 9.70117 6.08422 9.70117 8.96641V11.5H6.78125V14.8242H9.70117V22.8603C10.2866 22.9522 10.8868 23 11.498 23C12.1093 23 12.7094 22.9522 13.2949 22.8603V14.8242H15.9745Z"
            fill="white"
        />
    </svg>
)

export const WhatsAppLogo: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
            fill="#25D366"
        />
        <path
            d="M16.9257 6.03856C15.6132 4.72466 13.8681 4.00087 12.0087 4C8.17798 4 5.0595 7.11778 5.05828 10.9501C5.05758 12.1754 5.37777 13.3711 5.98587 14.4247L5 18.0265L8.68435 17.0602C9.6997 17.6135 10.8426 17.9054 12.0059 17.906H12.0089C15.8396 17.906 18.9576 14.7876 18.9592 10.9555C18.96 9.09859 18.2375 7.3523 16.9257 6.03856ZM12.0089 16.732H12.0066C10.9696 16.7316 9.95306 16.4532 9.06596 15.9269L8.855 15.8016L6.66864 16.3752L7.25196 14.2436L7.11464 14.0244C6.53621 13.1049 6.23068 12.0421 6.23137 10.9501C6.23242 7.76514 8.82412 5.17379 12.0106 5.17379C13.5538 5.17414 15.004 5.77596 16.0949 6.86809C17.1857 7.96004 17.7859 9.41127 17.7856 10.955C17.7845 14.1405 15.1928 16.732 12.0089 16.732ZM15.1776 12.4055C15.0038 12.3184 14.1501 11.8988 13.9908 11.8403C13.8314 11.7824 13.7161 11.7536 13.6002 11.9274C13.4844 12.1012 13.1516 12.4926 13.0501 12.6084C12.9489 12.7243 12.8477 12.739 12.6739 12.6519C12.5001 12.5648 11.9407 12.3816 11.2778 11.7897C10.7613 11.3296 10.4127 10.7604 10.3115 10.5866C10.2103 10.4128 10.3006 10.3191 10.3877 10.2324C10.4659 10.1546 10.5615 10.0297 10.6482 9.92811C10.735 9.82656 10.7639 9.75414 10.8218 9.63846C10.8798 9.5226 10.851 9.42122 10.8074 9.33432C10.7637 9.24725 10.4165 8.39243 10.272 8.04467C10.1309 7.70599 9.98779 7.75188 9.88135 7.74664C9.77979 7.74176 9.66411 7.74036 9.54842 7.74036C9.43273 7.74036 9.24446 7.78381 9.08533 7.95777C8.92637 8.13157 8.47758 8.55156 8.47758 9.40674C8.47758 10.2614 9.09981 11.0874 9.1867 11.2031C9.2736 11.3188 10.4113 13.0733 12.1534 13.8255C12.5676 14.0042 12.8913 14.1112 13.1434 14.1914C13.5594 14.3239 13.9381 14.3048 14.2375 14.2602C14.5711 14.2104 15.2649 13.8402 15.4099 13.4345C15.5545 13.029 15.5545 12.6814 15.5107 12.6088C15.4669 12.536 15.3511 12.4926 15.1776 12.4055Z"
            fill="white"
        />
    </svg>
)

export const MailIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
            fill="#FF666D"
        />
        <path
            d="M6.80768 16.0259C5.9488 16.0259 5.25 15.3272 5.25 14.4683V8.50632C5.25 7.64744 5.9488 6.94873 6.80768 6.94873H16.3324C17.1912 6.94873 17.8899 7.64744 17.8899 8.50632V14.4683C17.8899 15.3272 17.1912 16.0259 16.3324 16.0259H6.80768ZM6.80768 7.60777C6.31208 7.60777 5.90895 8.0109 5.90895 8.50632V14.4683C5.90895 14.9639 6.31208 15.367 6.80768 15.367H16.3324C16.8279 15.367 17.231 14.9639 17.231 14.4683V8.50632C17.231 8.01081 16.8279 7.60777 16.3324 7.60777H6.80768Z"
            fill="white"
            stroke="white"
            strokeWidth="0.71875"
        />
        <path
            d="M11.5697 12.5142C11.1407 12.5142 10.738 12.3648 10.4359 12.0935L5.76562 7.89994L6.20576 7.40961L10.8762 11.6031C11.0584 11.7667 11.3048 11.8568 11.5698 11.8568C11.8349 11.8568 12.0813 11.7667 12.2635 11.6031L16.9331 7.40961L17.3735 7.89994L12.7037 12.0935C12.4015 12.3648 11.9988 12.5142 11.5697 12.5142Z"
            fill="white"
            stroke="white"
            strokeWidth="0.71875"
        />
    </svg>
)

export const MessengerIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
            fill="#0072FF"
        />
        <path
            d="M11.5 4.9375C7.86719 4.9375 4.9375 7.65625 4.9375 11.0078C4.9375 12.7656 5.73437 14.3359 7.02344 15.4609C7.25781 15.6484 7.375 15.9297 7.375 16.2344V17.6641C7.375 17.8516 7.5625 17.9687 7.72656 17.875L9.25 17.0312C9.46094 16.9141 9.71875 16.8672 9.95312 16.9375C10.4453 17.0547 10.9609 17.1016 11.4766 17.1016C15.1094 17.1016 18.0391 14.3828 18.0391 11.0312C18.0391 7.67969 15.1328 4.9375 11.5 4.9375ZM14.8047 10.375L12.3906 13.0937C12.25 13.2344 12.0391 13.2578 11.875 13.1406L11.0547 12.4844C10.7031 12.2031 10.2344 12.1328 9.8125 12.2734L8.5 12.7187C8.14844 12.8359 7.84375 12.4141 8.10156 12.1094L10.5625 9.13281C10.7031 8.96875 10.9375 8.94531 11.1016 9.08594L11.9453 9.85937C12.2969 10.1875 12.8125 10.2812 13.2578 10.1406L14.4063 9.76562C14.7578 9.64844 15.0625 10.0703 14.8047 10.375Z"
            fill="white"
        />
    </svg>

)
export const RemoveIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z"
            fill="#FFEDE0"
            stroke="white"
            strokeWidth="3"
        />
        <path
            d="M31.5247 23.8723L26.2076 14.7517C25.7677 13.9987 25.1383 13.374 24.382 12.9399C23.6257 12.5058 22.7689 12.2773 21.8968 12.2773C21.0248 12.2773 20.168 12.5058 19.4116 12.9399C18.6553 13.374 18.0259 13.9987 17.5861 14.7517L12.269 23.8723C11.8309 24.6197 11.6 25.4704 11.6 26.3368C11.6 27.2031 11.8309 28.0538 12.269 28.8012C12.7037 29.5621 13.3324 30.1941 14.0912 30.6326C14.8499 31.0711 15.7113 31.3005 16.5877 31.2973H27.206C28.085 31.3033 28.9498 31.0753 29.7115 30.6366C30.4733 30.1979 31.1045 29.5644 31.5405 28.8012C31.9762 28.0524 32.2044 27.2009 32.2016 26.3346C32.1988 25.4683 31.9652 24.6183 31.5247 23.8723ZM21.8968 28.1276C21.6618 28.1276 21.4319 28.0579 21.2365 27.9273C21.041 27.7967 20.8887 27.611 20.7987 27.3939C20.7087 27.1767 20.6852 26.9377 20.7311 26.7071C20.7769 26.4765 20.8901 26.2647 21.0564 26.0985C21.2226 25.9323 21.4344 25.8191 21.6649 25.7732C21.8955 25.7273 22.1345 25.7509 22.3517 25.8408C22.5689 25.9308 22.7545 26.0832 22.8851 26.2786C23.0157 26.4741 23.0855 26.7039 23.0855 26.939C23.0855 27.2542 22.9602 27.5566 22.7373 27.7795C22.5144 28.0024 22.2121 28.1276 21.8968 28.1276ZM23.862 19.5537L22.6893 24.3557C22.6463 24.5271 22.5473 24.6791 22.4081 24.7878C22.2688 24.8965 22.0973 24.9555 21.9206 24.9555C21.744 24.9555 21.5724 24.8965 21.4331 24.7878C21.2939 24.6791 21.1949 24.5271 21.152 24.3557L19.9554 19.5537C19.8774 19.2578 19.869 18.9478 19.9308 18.6481C19.9927 18.3484 20.1232 18.0671 20.312 17.8262C20.502 17.5884 20.7432 17.3964 21.0175 17.2644C21.2919 17.1325 21.5924 17.0639 21.8968 17.0639C22.2013 17.0639 22.5018 17.1325 22.7762 17.2644C23.0505 17.3964 23.2916 17.5884 23.4817 17.8262C23.6746 18.065 23.8093 18.3454 23.8754 18.6452C23.9414 18.9449 23.9368 19.256 23.862 19.5537Z"
            fill="#EE731B"
        />
    </svg>

)

export const WarningIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg className='max-w-[44px] w-full' width="44" height="41" viewBox="0 0 44 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M41.9717 25.179L30.7712 5.96612C29.8447 4.3799 28.5188 3.06405 26.9256 2.14957C25.3325 1.2351 23.5275 0.753906 21.6905 0.753906C19.8536 0.753906 18.0486 1.2351 16.4554 2.14957C14.8623 3.06405 13.5364 4.3799 12.6099 5.96612L1.40934 25.179C0.486483 26.7534 0 28.5454 0 30.3703C0 32.1953 0.486483 33.9872 1.40934 35.5616C2.32494 37.1646 3.64947 38.4958 5.24771 39.4196C6.84595 40.3434 8.66068 40.8265 10.5067 40.8197H32.8744C34.726 40.8324 36.5477 40.3521 38.1523 39.428C39.757 38.504 41.0867 37.1695 42.0051 35.5616C42.9229 33.9843 43.4036 32.1907 43.3978 30.3658C43.3919 28.5408 42.8997 26.7504 41.9717 25.179V25.179ZM21.6905 34.1428C21.1953 34.1428 20.7112 33.9959 20.2995 33.7208C19.8877 33.4457 19.5668 33.0546 19.3773 32.5971C19.1878 32.1396 19.1382 31.6362 19.2348 31.1505C19.3314 30.6648 19.5699 30.2186 19.92 29.8684C20.2702 29.5183 20.7164 29.2798 21.2021 29.1832C21.6878 29.0866 22.1912 29.1362 22.6487 29.3257C23.1062 29.5152 23.4973 29.8361 23.7724 30.2479C24.0475 30.6596 24.1944 31.1437 24.1944 31.6389C24.1944 32.303 23.9306 32.9399 23.461 33.4094C22.9915 33.879 22.3546 34.1428 21.6905 34.1428ZM25.8302 16.0817L23.3598 26.1972C23.2693 26.5582 23.0609 26.8785 22.7675 27.1074C22.4741 27.3363 22.1127 27.4607 21.7406 27.4607C21.3685 27.4607 21.0071 27.3363 20.7137 27.1074C20.4204 26.8785 20.2119 26.5582 20.1215 26.1972L17.6009 16.0817C17.4365 15.4583 17.4188 14.8054 17.5491 14.174C17.6795 13.5426 17.9543 12.9501 18.3521 12.4427C18.7524 11.9417 19.2603 11.5372 19.8382 11.2593C20.4162 10.9813 21.0492 10.8369 21.6905 10.8369C22.3318 10.8369 22.9649 10.9813 23.5428 11.2593C24.1208 11.5372 24.6287 11.9417 25.029 12.4427C25.4354 12.9458 25.7193 13.5363 25.8583 14.1678C25.9974 14.7993 25.9877 15.4545 25.8302 16.0817Z"
            fill="#EE731B"
        />
    </svg>
)

export const ThreeDots: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 14.25C3.90326 14.25 3.33097 14.0129 2.90901 13.591C2.48705 13.169 2.25 12.5967 2.25 12C2.25 11.4033 2.48705 10.831 2.90901 10.409C3.33097 9.98705 3.90326 9.75 4.5 9.75C5.09674 9.75 5.66903 9.98705 6.09099 10.409C6.51295 10.831 6.75 11.4033 6.75 12C6.75 12.5967 6.51295 13.169 6.09099 13.591C5.66903 14.0129 5.09674 14.25 4.5 14.25ZM12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12C9.75 11.4033 9.98705 10.831 10.409 10.409C10.831 9.98705 11.4033 9.75 12 9.75C12.5967 9.75 13.169 9.98705 13.591 10.409C14.0129 10.831 14.25 11.4033 14.25 12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25ZM19.5 14.25C18.9033 14.25 18.331 14.0129 17.909 13.591C17.4871 13.169 17.25 12.5967 17.25 12C17.25 11.4033 17.4871 10.831 17.909 10.409C18.331 9.98705 18.9033 9.75 19.5 9.75C20.0967 9.75 20.669 9.98705 21.091 10.409C21.5129 10.831 21.75 11.4033 21.75 12C21.75 12.5967 21.5129 13.169 21.091 13.591C20.669 14.0129 20.0967 14.25 19.5 14.25Z"
            fill="#757575"
        />
    </svg>
)

export const PDFIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
    <svg className={props.className} width={props.width ? props.width : "21"} height={props.height ? props.height : "24"} viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 0C3.675 0 3 0.675 3 1.5V22.5C3 23.325 3.675 24 4.5 24H19.5C20.325 24 21 23.325 21 22.5V6L15 0H4.5Z"
            fill="#E2E5E7"
        />
        <path d="M16.5 6H21L15 0V4.5C15 5.325 15.675 6 16.5 6Z" fill="#B0B7BD" />
        <path d="M21 10.5L16.5 6H21V10.5Z" fill="#CAD1D8" />
        <path
            d="M18 19.5C18 19.9125 17.6625 20.25 17.25 20.25H0.75C0.3375 20.25 0 19.9125 0 19.5V12C0 11.5875 0.3375 11.25 0.75 11.25H17.25C17.6625 11.25 18 11.5875 18 12V19.5Z"
            fill="#F15642"
        />
        <path
            d="M3.26904 14.2099C3.26904 14.0119 3.42504 13.7959 3.67629 13.7959H5.06154C5.84154 13.7959 6.54354 14.3179 6.54354 15.3184C6.54354 16.2664 5.84154 16.7944 5.06154 16.7944H4.06029V17.5864C4.06029 17.8504 3.89229 17.9996 3.67629 17.9996C3.47829 17.9996 3.26904 17.8504 3.26904 17.5864V14.2099ZM4.06029 14.5511V16.0451H5.06154C5.46354 16.0451 5.78154 15.6904 5.78154 15.3184C5.78154 14.8991 5.46354 14.5511 5.06154 14.5511H4.06029Z"
            fill="white"
        />
        <path
            d="M7.7182 18.0003C7.5202 18.0003 7.3042 17.8923 7.3042 17.6291V14.2226C7.3042 14.0073 7.5202 13.8506 7.7182 13.8506H9.09145C11.8319 13.8506 11.7719 18.0003 9.14545 18.0003H7.7182ZM8.0962 14.5826V17.2691H9.09145C10.7107 17.2691 10.7827 14.5826 9.09145 14.5826H8.0962Z"
            fill="white"
        />
        <path
            d="M12.744 14.6284V15.5817H14.2732C14.4892 15.5817 14.7052 15.7977 14.7052 16.0069C14.7052 16.2049 14.4892 16.3669 14.2732 16.3669H12.744V17.6262C12.744 17.8362 12.5947 17.9974 12.3847 17.9974C12.1207 17.9974 11.9595 17.8362 11.9595 17.6262V14.2197C11.9595 14.0044 12.1215 13.8477 12.3847 13.8477H14.49C14.754 13.8477 14.91 14.0044 14.91 14.2197C14.91 14.4117 14.754 14.6277 14.49 14.6277H12.744V14.6284Z"
            fill="white"
        />
        <path
            d="M17.25 20.25H3V21H17.25C17.6625 21 18 20.6625 18 20.25V19.5C18 19.9125 17.6625 20.25 17.25 20.25Z"
            fill="#CAD1D8"
        />
    </svg>
)
export const DocIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
    <svg className={props.className} width={props.width ? props.width : "21"} height={props.height ? props.height : "24"} viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1238_10176)">
            <path
                d="M4.5 0.0722656C3.675 0.0722656 3 0.747266 3 1.57227V22.5723C3 23.3973 3.675 24.0723 4.5 24.0723H19.5C20.325 24.0723 21 23.3973 21 22.5723V6.07227L15 0.0722656H4.5Z"
                fill="#E2E5E7"
            />
            <path d="M16.5 6.07227H21L15 0.0722656V4.57227C15 5.39727 15.675 6.07227 16.5 6.07227Z" fill="#B0B7BD" />
            <path d="M21 10.5693L16.5 6.06934H21V10.5693Z" fill="#CAD1D8" />
            <path
                d="M18 19.5693C18 19.9818 17.6625 20.3193 17.25 20.3193H0.75C0.3375 20.3193 0 19.9818 0 19.5693V12.0693C0 11.6568 0.3375 11.3193 0.75 11.3193H17.25C17.6625 11.3193 18 11.6568 18 12.0693V19.5693Z"
                fill="#50BEE8"
            />
            <path
                d="M2.83929 18.0706C2.64129 18.0706 2.42529 17.9619 2.42529 17.6986V14.2929C2.42529 14.0769 2.64129 13.9209 2.83929 13.9209H4.21254C6.95304 13.9209 6.89229 18.0706 4.26579 18.0706H2.83929ZM3.21729 14.6521V17.3386H4.21254C5.83179 17.3386 5.90304 14.6521 4.21254 14.6521H3.21729Z"
                fill="white"
            />
            <path
                d="M9.18752 18.1312C8.07827 18.1792 6.92627 17.4412 6.92627 15.972C6.92627 14.4967 8.07752 13.7715 9.18752 13.7715C10.2368 13.8247 11.334 14.5507 11.334 15.972C11.334 17.394 10.2368 18.1312 9.18752 18.1312ZM9.12152 14.5515C8.44952 14.5515 7.71827 15.0255 7.71827 15.9727C7.71827 16.9147 8.45027 17.3947 9.12152 17.3947C9.81152 17.3947 10.5488 16.9147 10.5488 15.9727C10.5488 15.0247 9.81152 14.5515 9.12152 14.5515Z"
                fill="white"
            />
            <path
                d="M12.0396 15.9679C12.0396 14.8107 12.7656 13.8154 14.1448 13.8154C14.6668 13.8154 15.0808 13.9714 15.5181 14.3494C15.6801 14.4987 15.6981 14.7627 15.5361 14.9307C15.3741 15.0739 15.1281 15.0567 14.9841 14.9127C14.7388 14.6547 14.4868 14.5834 14.1448 14.5834C13.2216 14.5834 12.7783 15.2374 12.7783 15.9687C12.7783 16.7127 13.2156 17.3959 14.1448 17.3959C14.4868 17.3959 14.8048 17.2572 15.0808 17.0119C15.2661 16.8679 15.5241 16.9392 15.6321 17.0839C15.7281 17.2159 15.7753 17.4379 15.5661 17.6472C15.1461 18.0379 14.6428 18.1159 14.1441 18.1159C12.6936 18.1159 12.0396 17.1252 12.0396 15.9679Z"
                fill="white"
            />
            <path
                d="M17.25 20.3193H3V21.0693H17.25C17.6625 21.0693 18 20.7318 18 20.3193V19.5693C18 19.9818 17.6625 20.3193 17.25 20.3193Z"
                fill="#CAD1D8"
            />
        </g>
        <defs>
            <clipPath id="clip0_1238_10176">
                <rect width="21" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export const ParticipantsIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1238_10491)">
            <path
                d="M13.7498 9.66374C17.4998 9.66374 18.1248 2.6638 13.7498 2.6638C9.37481 2.6638 9.99981 9.66374 13.7498 9.66374ZM13.7498 4.25707C16.2498 4.25707 15.6248 8.07054 13.7498 8.07054C11.8748 8.07054 11.2498 4.25707 13.7498 4.25707ZM18.9914 14.4904C18.6886 11.1504 15.267 10.3042 12.3243 10.7918C12.6246 11.2538 12.8482 11.7716 12.9917 12.3402C14.9511 12.1672 17.308 12.5152 17.4977 14.6053L17.5532 15.3331H19.0558L18.9914 14.4904ZM6.24981 8.33107C10.3123 8.33107 11.2498 0.997803 6.24981 0.997803C1.56231 0.997836 2.49981 8.33107 6.24981 8.33107ZM6.40453 2.5548C7.07103 2.5548 8.1895 2.66647 8.1895 4.33314C8.1895 7.66647 4.61928 7.66647 4.61928 4.33314C4.61928 2.66647 5.73772 2.5548 6.40453 2.5548ZM6.40956 9.33147C1.81118 9.33147 0.829871 11.8656 0.690246 13.3884L0.653809 15.3331H2.13868L2.184 13.5048C2.3384 11.8196 3.84312 10.9644 6.40959 10.9644C8.97634 10.9644 10.4814 11.82 10.6347 13.4928L10.6755 15.3331H12.182L12.1284 13.376C11.9899 11.8656 11.0084 9.33147 6.40956 9.33147Z"
                fill="#333333"
            />
        </g>
        <defs>
            <clipPath id="clip0_1238_10491">
                <rect width="20" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const ShareGroup: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1238_10503)">
            <path
                d="M9.01292 1.71429H5.14286C4.66947 1.71429 4.28571 1.33053 4.28571 0.857142C4.28571 0.383756 4.66947 0 5.14286 0H11.1429C11.6162 0 12 0.383756 12 0.857142V6.85714C12 7.33053 11.6162 7.71429 11.1429 7.71429C10.6695 7.71429 10.2857 7.33053 10.2857 6.85714V2.98708L1.5364 11.7364C1.18492 12.0879 0.615076 12.0879 0.263604 11.7364C-0.087868 11.3849 -0.087868 10.8151 0.263604 10.4636L9.01292 1.71429Z"
                fill="#333333"
            />
        </g>
        <defs>
            <clipPath id="clip0_1238_10503">
                <rect width="12" height="12" fill="white" transform="matrix(0 -1 1 0 0 12)" />
            </clipPath>
        </defs>
    </svg>
)

export const UnMuteIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1238_10497)">
            <path
                d="M11.4459 12.7917H2.55129C2.33266 12.8006 2.1144 12.7666 1.90901 12.6916C1.70363 12.6166 1.51514 12.5021 1.35436 12.3546C1.19357 12.2071 1.06364 12.0295 0.971998 11.8321C0.880359 11.6346 0.828813 11.4211 0.820312 11.2038C0.833279 10.5727 1.0344 9.95969 1.39819 9.44229C1.99791 8.49495 2.28037 7.38321 2.2051 6.26649C2.2051 2.62332 3.90944 0.617798 6.99857 0.617798C10.0877 0.617798 11.7921 2.62332 11.7921 6.26808C11.7168 7.3848 11.9992 8.49653 12.599 9.44388C12.9625 9.96083 13.1636 10.5733 13.1768 11.2038C13.1683 11.4211 13.1168 11.6346 13.0251 11.8321C12.9335 12.0295 12.8036 12.2071 12.6428 12.3546C12.482 12.5021 12.2935 12.6166 12.0881 12.6916C11.8827 12.7666 11.6645 12.8006 11.4459 12.7917ZM6.99857 1.6764C4.52461 1.6764 3.27031 3.22143 3.27031 6.26808C3.34404 7.57369 3.01075 8.87013 2.31588 9.98059C2.05063 10.3354 1.90051 10.7621 1.88553 11.2038C1.88553 11.6394 2.41814 11.7331 2.55129 11.7331H11.4459C11.5779 11.7331 12.1116 11.6394 12.1116 11.2038C12.0967 10.7619 11.9466 10.335 11.6813 9.98006C10.9865 8.86975 10.6532 7.57351 10.7268 6.26808C10.7268 3.22143 9.47254 1.6764 6.99857 1.6764Z"
                fill="#333333"
                stroke="#333333"
                strokeWidth="0.4"
            />
            <path
                d="M7.00022 15.2093C6.48462 15.2086 5.99034 15.0047 5.6258 14.6424C5.26127 14.28 5.05623 13.7887 5.05567 13.2763C5.05547 13.1555 5.06724 13.0349 5.09082 12.9164C5.1046 12.8483 5.13175 12.7835 5.17072 12.7257C5.2097 12.668 5.25973 12.6185 5.31797 12.58C5.3762 12.5415 5.4415 12.5147 5.51013 12.5013C5.57876 12.4879 5.64939 12.488 5.71797 12.5017C5.78655 12.5154 5.85174 12.5424 5.90983 12.5811C5.96791 12.6198 6.01775 12.6696 6.0565 12.7274C6.09525 12.7853 6.12215 12.8502 6.13567 12.9184C6.14918 12.9866 6.14904 13.0568 6.13527 13.125C6.12535 13.1748 6.12053 13.2255 6.12088 13.2763C6.11678 13.3936 6.13647 13.5105 6.17878 13.62C6.2211 13.7295 6.28517 13.8294 6.36718 13.9138C6.44919 13.9982 6.54746 14.0653 6.65613 14.1112C6.76479 14.157 6.88164 14.1806 6.99969 14.1806C7.11774 14.1806 7.23459 14.157 7.34325 14.1112C7.45192 14.0653 7.55019 13.9982 7.6322 13.9138C7.71421 13.8294 7.77828 13.7295 7.8206 13.62C7.86291 13.5105 7.8826 13.3936 7.8785 13.2763C7.87885 13.2255 7.87403 13.1748 7.86411 13.125C7.85034 13.0568 7.8502 12.9866 7.86371 12.9184C7.87723 12.8502 7.90413 12.7853 7.94288 12.7274C7.98163 12.6696 8.03147 12.6198 8.08955 12.5811C8.14764 12.5424 8.21283 12.5154 8.28141 12.5017C8.34999 12.488 8.42062 12.4879 8.48925 12.5013C8.55788 12.5147 8.62318 12.5415 8.68141 12.58C8.73965 12.6185 8.78968 12.668 8.82866 12.7257C8.86763 12.7835 8.89478 12.8483 8.90856 12.9164C8.93214 13.0349 8.94391 13.1555 8.94371 13.2763C8.94315 13.7886 8.73826 14.2797 8.37395 14.642C8.00965 15.0043 7.51564 15.2084 7.00022 15.2093Z"
                fill="#333333"
                stroke="#333333"
                strokeWidth="0.2"
            />
        </g>
        <defs>
            <clipPath id="clip0_1238_10497">
                <rect width="14" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export const LeaveGroup: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1238_10509)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.25231 11.5098C1.01054 11.5098 0 10.494 0 9.2522L0 3.24904C0 2.00802 1.00904 0.998987 2.25006 0.998987H5.25539C5.66981 0.998987 6.00616 1.33533 6.00616 1.74976C6.00616 2.16418 5.66981 2.50053 5.25539 2.50053H2.25006C1.83713 2.50053 1.50154 2.83612 1.50154 3.24904L1.50154 9.2522C1.50154 9.66663 1.83788 10.0082 2.25231 10.0082H5.25539C5.66981 10.0082 6.00616 10.3446 6.00616 10.759C6.00616 11.1734 5.66981 11.5098 5.25539 11.5098H2.25231ZM12 6.24763C12 6.43977 11.9267 6.63191 11.7801 6.77851L9.65661 8.902C9.36341 9.1952 8.88805 9.1952 8.59486 8.902C8.30166 8.60881 8.30166 8.13345 8.59486 7.84026L9.43671 6.9984L5.25139 6.9984C4.83675 6.9984 4.50062 6.66227 4.50062 6.24763C4.50062 5.83299 4.83675 5.49686 5.25139 5.49686L9.43671 5.49686L8.59486 4.65501C8.30166 4.36181 8.30166 3.88645 8.59486 3.59326C8.88805 3.30007 9.36341 3.30007 9.65661 3.59326L11.7801 5.71676C11.9267 5.86335 12 6.05549 12 6.24763Z"
                fill="#333333"
            />
        </g>
        <defs>
            <clipPath id="clip0_1238_10509">
                <rect width="12.0002" height="12" fill="white" transform="matrix(-1 0 0 -1 12 12)" />
            </clipPath>
        </defs>
    </svg>
)
export const BackArrow: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 5L8 13L16 21" stroke="#4A4A4A" strokeWidth="2" strokeLinecap="round" />
    </svg>
)
export const PinnedChat: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <>
        <svg width="20" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2783_61750)">
                <path
                    d="M2.57895 5.59263L1 5.85842L5.85789 1L5.59263 2.57895L2.57895 5.59263ZM6.26316 8.83211L5.85789 9.90684L9.90684 5.85842L8.83211 6.26316L6.26316 8.83211ZM7.88263 7.88263L11 11L7.88263 7.88263ZM1.80947 5.04842L5.04842 1.80947L5.17263 1.98895C6.30118 3.61898 7.60279 5.12211 9.05474 6.47211L9.17842 6.58684L6.58684 9.1779L6.47211 9.05474C5.12228 7.60282 3.61932 6.30121 1.98947 5.17263L1.81053 5.04842H1.80947Z"
                    stroke="#333333"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2783_61750">
                    <rect width="12" height="12" fill="white" transform="matrix(0 -1 1 0 0 12)" />
                </clipPath>
            </defs>
        </svg>
    </>
)
export const EmptyChat: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <img className="w-195px h-auto" src="https://images.myyogateacher.com/chat/emptyChat.png" />
)
export const NoMessageEmoji: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.35914 56.2907L7.71579 55.2211L7.15025 54.2458C0.965203 43.579 0.948926 30.4174 7.10757 19.7353C13.2661 9.05338 24.6595 2.48083 36.9814 2.5001L36.988 2.50009C51.4892 2.48482 64.4508 11.5531 69.4154 25.1901C74.3801 38.8275 70.2848 54.1155 59.1708 63.4391C48.0572 72.7623 32.3017 74.1283 19.7517 66.857L18.7761 66.2918L17.7066 66.6489L3.27947 71.4665C3.07137 71.5359 2.84159 71.4819 2.6858 71.326C2.52988 71.17 2.47495 70.9386 2.54483 70.7283C2.54488 70.7282 2.54493 70.728 2.54498 70.7279L7.35914 56.2907Z"
            fill="#7D4AC3"
            fillOpacity="0.1"
            stroke="#7D4AC3"
            strokeWidth="5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.4657 31C26.4293 31 25.5892 31.8423 25.5892 32.8814C25.6081 33.4016 25.3421 33.8905 24.8957 34.1562C24.4493 34.4219 23.8938 34.4219 23.4474 34.1562C23.001 33.8905 22.735 33.4016 22.7539 32.8814C22.7539 31.8423 21.9138 31 20.8774 31C19.8411 31 19.0009 31.8423 19.0009 32.8814C18.9653 34.7571 19.9429 36.5058 21.5574 37.4541C23.1718 38.4024 25.1713 38.4024 26.7857 37.4541C28.4001 36.5058 29.3778 34.7571 29.3421 32.8814C29.3421 32.3824 29.1444 31.9039 28.7925 31.5511C28.4406 31.1982 27.9633 31 27.4657 31ZM45.0687 47.8675C45.003 48.0782 43.3554 53 36.9999 53C30.6443 53 28.993 48.0782 28.9311 47.8675C28.6728 47.2147 28.7987 46.4721 29.2575 45.9414C29.7163 45.4108 30.4316 45.1806 31.1127 45.3442C31.791 45.5073 32.3229 46.034 32.4942 46.7114C32.6217 47.0511 33.574 49.2391 36.9905 49.2391C40.4826 49.2391 41.4058 46.9531 41.494 46.6916V46.7198C41.663 46.0383 42.1965 45.5079 42.8776 45.3442C43.5587 45.1806 44.2741 45.4108 44.7329 45.9414C45.1917 46.4721 45.3175 47.2147 45.0593 47.8675H45.0687ZM50.5526 34.1562C50.999 33.8905 51.265 33.4016 51.2461 32.8814C51.2461 31.8423 52.0863 31 53.1226 31C53.6203 31 54.0975 31.1982 54.4495 31.5511C54.8014 31.9039 54.9991 32.3824 54.9991 32.8814C55.0347 34.7571 54.0571 36.5058 52.4426 37.4541C50.8282 38.4024 48.8287 38.4024 47.2143 37.4541C45.5999 36.5058 44.6222 34.7571 44.6579 32.8814C44.6579 31.8423 45.498 31 46.5343 31C47.5707 31 48.4108 31.8423 48.4108 32.8814C48.3919 33.4016 48.6579 33.8905 49.1043 34.1562C49.5507 34.4219 50.1062 34.4219 50.5526 34.1562Z"
            fill="#7D4AC3"
        />
    </svg>
)
export const Download: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25'
            stroke='#321A50'
            strokeWidth='1.7'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.24969 7.5L8.99969 11.25L12.7497 7.5'
            stroke='#321A50'
            strokeWidth='1.7'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9 11.25V2.25'
            stroke='#321A50'
            strokeWidth='1.7'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
)
export const TwitterLogo: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        width='22'
        height='22'
        viewBox='0 0 22 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clipPath='url(#clip0_3326_52714)'>
            <path
                d='M3.85 22.5L18.15 22.5C20.2763 22.5 22 20.7763 22 18.65L22 4.35C22 2.2237 20.2763 0.5 18.15 0.5L3.85 0.5C1.7237 0.5 0 2.2237 0 4.35L0 18.65C0 20.7763 1.7237 22.5 3.85 22.5Z'
                fill='#00AADE'
            />
            <path
                d='M16.225 7.64977C16.5532 7.48106 16.844 7.24803 17.0802 6.96456C17.3165 6.68109 17.4932 6.35298 17.6 5.99977C17.05 6.54977 15.8813 6.73196 15.8813 6.73196C15.4771 6.23539 14.9124 5.89538 14.2845 5.77055C13.6565 5.64573 13.0047 5.74391 12.4414 6.04817C11.8781 6.35243 11.4386 6.8437 11.1987 7.43728C10.9588 8.03086 10.9335 8.68955 11.1272 9.29977H11C9.87982 9.22549 8.78752 8.91804 7.79305 8.39713C6.79858 7.87622 5.92389 7.15333 5.225 6.27477C5.225 6.27477 3.575 8.47477 6.05 10.1248C6.05 10.1248 4.95 10.1248 4.675 9.84977C4.675 9.84977 4.4 11.4998 6.875 12.5998C6.70231 12.6784 6.51476 12.7191 6.325 12.7191C6.13524 12.7191 5.94769 12.6784 5.775 12.5998C5.775 13.662 6.88188 14.5248 8.25 14.5248C8.25 15.2845 6.40406 15.8998 4.125 15.8998C7.7 18.3748 16.225 17.8248 16.775 8.47477L18.15 7.09977L16.225 7.64977Z'
                fill='white'
            />
        </g>
        <defs>
            <clipPath id='clip0_3326_52714'>
                <rect
                    width='22'
                    height='22'
                    fill='white'
                    transform='translate(0 0.5)'
                />
            </clipPath>
        </defs>
    </svg>
)
export const ShareIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.69617 9.21695V5L13.1948 8.49866L16 11.3038L13.145 13.6831L9.69617 16.5574V12.4096C3.64135 11.9532 1.52 16.457 1.52 16.457C1.52 14.274 2.5 13 4.41613 11.293C6.5 9.5 8.30028 9.156 9.69617 9.21695Z"
            fill="#321A50" />
    </svg>
)
export const BlackChevronDown: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 1L6.5 6L11.5 1" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </svg>
)


interface EmojiPickerIconProps {
    onClick: MouseEventHandler<SVGSVGElement>
}

export const EmojiPickerIcon: React.FunctionComponent<EmojiPickerIconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            className="mx-1 cursor-pointer md:flex zm:hidden"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.80122 18.6931C14.7122 18.6931 18.6933 14.712 18.6933 9.8011C18.6933 4.89016 14.7122 0.909058 9.80122 0.909058C4.89028 0.909058 0.90918 4.89016 0.90918 9.8011C0.90918 14.712 4.89028 18.6931 9.80122 18.6931Z"
                stroke="#888888"
                strokeWidth="1.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.72327 8.43311C7.28992 8.43311 7.74928 7.97376 7.74928 7.40711C7.74928 6.84046 7.28992 6.3811 6.72327 6.3811C6.15662 6.3811 5.69727 6.84046 5.69727 7.40711C5.69727 7.97376 6.15662 8.43311 6.72327 8.43311Z"
                fill="#888888"
            />
            <path
                d="M12.879 8.43311C13.4457 8.43311 13.905 7.97376 13.905 7.40711C13.905 6.84046 13.4457 6.3811 12.879 6.3811C12.3124 6.3811 11.853 6.84046 11.853 7.40711C11.853 7.97376 12.3124 8.43311 12.879 8.43311Z"
                fill="#888888"
            />
            <path
                d="M13.2214 11.8531C12.8418 12.4222 11.8534 13.9052 9.80137 13.9052C7.74935 13.9052 6.76097 12.4222 6.38135 11.8531"
                stroke="#888888"
                strokeWidth="1.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

interface SendIconProps {
    onClick: MouseEventHandler<SVGSVGElement>
}

export const SendIcon: React.FunctionComponent<SendIconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            className="md:ml-11px cursor-pointer"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="28" height="28" rx="14" fill="#EE731B" />
            <path
                d="M12.2935 17.6182L14.1371 21.4647C14.4102 22.011 15.1841 21.9882 15.4117 21.4192L20.6238 8.05885C20.8514 7.48984 20.2824 6.92083 19.7134 7.14843L6.71719 12.3833C6.17094 12.6109 6.12542 13.3848 6.64891 13.6579L10.1313 15.4787C10.4727 15.6608 10.8596 15.6153 11.1782 15.4105L15.2751 12.4971L12.3845 16.6168C12.1797 16.9126 12.1569 17.2996 12.2935 17.6182Z"
                fill="white"
            />
        </svg>
    )
}

export const BackChevron: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="mr-2.5"
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7 1L1 7L7 13"
            stroke="black"
            strokeOpacity="0.4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const BottomChevron: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="h-12 w-12 "
        width="78"
        height="78"
        viewBox="0 0 78 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_285_3514)">
            <circle cx="39" cy="39" r="25" fill="white" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.1053 44.6027L30.3467 36.1912C29.8713 35.6761 29.8868 34.8566 30.3811 34.3613C30.8752 33.866 31.661 33.8818 32.1361 34.3972L39 41.8388L45.8639 34.3972C46.3387 33.8822 47.1245 33.866 47.6189 34.3613C48.1132 34.8566 48.1287 35.6761 47.6533 36.1912L39.8947 44.6027C39.6607 44.8567 39.3377 45 39 45C38.6623 45 38.3393 44.8567 38.1053 44.6027Z"
            fill="#92A1BF"
        />
        <defs>
            <filter
                id="filter0_d_285_3514"
                x="0"
                y="0"
                width="78"
                height="78"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="7" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.670969 0 0 0 0 0.670969 0 0 0 0 0.670969 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_285_3514" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_285_3514" result="shape" />
            </filter>
        </defs>
    </svg>
)

export const DownArrow: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="ml-2.5"
        width="15"
        height="10"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.42822 2.92822L7.99965 8.49965L13.5711 2.92822"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SmallWarnIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="mr-2 mt-0.5"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M19.9247 11.595L14.6076 2.47432C14.1678 1.72132 13.5384 1.09666 12.7821 0.662546C12.0257 0.22843 11.1689 0 10.2969 0C9.42482 0 8.56798 0.22843 7.81167 0.662546C7.05536 1.09666 6.42596 1.72132 5.98613 2.47432L0.669039 11.595C0.230941 12.3424 0 13.1931 0 14.0594C0 14.9257 0.230941 15.7764 0.669039 16.5238C1.10369 17.2848 1.73246 17.9167 2.49118 18.3553C3.24989 18.7938 4.11137 19.0231 4.98769 19.0199H15.606C16.485 19.026 17.3498 18.7979 18.1115 18.3593C18.8733 17.9206 19.5046 17.2871 19.9405 16.5238C20.3762 15.775 20.6044 14.9236 20.6017 14.0573C20.5989 13.1909 20.3652 12.341 19.9247 11.595ZM10.2969 15.8503C10.0618 15.8503 9.83197 15.7806 9.6365 15.6499C9.44103 15.5193 9.28868 15.3337 9.19872 15.1165C9.10876 14.8993 9.08522 14.6603 9.13108 14.4298C9.17694 14.1992 9.29015 13.9874 9.45638 13.8212C9.62261 13.6549 9.8344 13.5417 10.065 13.4959C10.2955 13.45 10.5345 13.4735 10.7517 13.5635C10.9689 13.6535 11.1546 13.8058 11.2852 14.0013C11.4158 14.1968 11.4855 14.4266 11.4855 14.6616C11.4855 14.9769 11.3603 15.2792 11.1373 15.5021C10.9144 15.725 10.6121 15.8503 10.2969 15.8503ZM12.262 7.27635L11.0893 12.0784C11.0463 12.2497 10.9474 12.4018 10.8081 12.5105C10.6689 12.6191 10.4973 12.6781 10.3206 12.6781C10.144 12.6781 9.97242 12.6191 9.83316 12.5105C9.6939 12.4018 9.59494 12.2497 9.55199 12.0784L8.35545 7.27635C8.27742 6.98043 8.269 6.67046 8.33087 6.37074C8.39274 6.07103 8.52321 5.78972 8.71204 5.54889C8.90207 5.31105 9.1432 5.11903 9.41755 4.98707C9.6919 4.85511 9.99243 4.78659 10.2969 4.78659C10.6013 4.78659 10.9018 4.85511 11.1762 4.98707C11.4505 5.11903 11.6917 5.31105 11.8817 5.54889C12.0746 5.78767 12.2094 6.06802 12.2754 6.36781C12.3414 6.6676 12.3368 6.97863 12.262 7.27635Z"
            fill="black" />
    </svg>
)

export const ArrowRight = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <path d='M9 18L15 12L9 6' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export const StudentHeaderHamburger = () => {
    return (
        <svg
            fill='none'
            viewBox='0 0 26 16'
            xmlns='http://www.w3.org/2000/svg'
            width='26'
            height='16'
        >
            <rect width='35' height='2' rx='1' fill='#272727'></rect>
            <rect y='6' width='35' height='2' rx='2' fill='#272727'></rect>
            <rect y='12' width='35' height='2' rx='2' fill='#272727'></rect>
        </svg>
    )
}
export const SmallWhiteFillWarnIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="mr-2 mt-0.5"
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.5248 11.8723L15.2077 2.75167C14.7679 1.99866 14.1385 1.37401 13.3822 0.93989C12.6258 0.505774 11.769 0.277344 10.897 0.277344C10.0249 0.277344 9.16808 0.505774 8.41177 0.93989C7.65546 1.37401 7.02606 1.99866 6.58623 2.75167L1.26914 11.8723C0.831039 12.6197 0.600098 13.4704 0.600098 14.3368C0.600098 15.2031 0.831039 16.0538 1.26914 16.8012C1.70379 17.5621 2.33256 18.1941 3.09127 18.6326C3.84999 19.0711 4.71147 19.3005 5.58779 19.2973H16.2061C17.0851 19.3033 17.9499 19.0753 18.7116 18.6366C19.4734 18.1979 20.1047 17.5644 20.5406 16.8012C20.9763 16.0524 21.2045 15.2009 21.2018 14.3346C21.199 13.4683 20.9653 12.6183 20.5248 11.8723ZM10.897 16.1276C10.6619 16.1276 10.4321 16.0579 10.2366 15.9273C10.0411 15.7967 9.88878 15.611 9.79882 15.3939C9.70885 15.1767 9.68532 14.9377 9.73118 14.7071C9.77704 14.4765 9.89025 14.2647 10.0565 14.0985C10.2227 13.9323 10.4345 13.8191 10.6651 13.7732C10.8956 13.7273 11.1346 13.7509 11.3518 13.8408C11.569 13.9308 11.7547 14.0832 11.8853 14.2786C12.0159 14.4741 12.0856 14.7039 12.0856 14.939C12.0856 15.2542 11.9604 15.5566 11.7374 15.7795C11.5145 16.0024 11.2122 16.1276 10.897 16.1276ZM12.8621 7.55369L11.6894 12.3557C11.6464 12.5271 11.5475 12.6791 11.4082 12.7878C11.269 12.8965 11.0974 12.9555 10.9207 12.9555C10.7441 12.9555 10.5725 12.8965 10.4333 12.7878C10.294 12.6791 10.195 12.5271 10.1521 12.3557L8.95555 7.55369C8.87751 7.25778 8.8691 6.9478 8.93097 6.64809C8.99284 6.34837 9.1233 6.06706 9.31213 5.82623C9.50217 5.58839 9.7433 5.39637 10.0176 5.26441C10.292 5.13245 10.5925 5.06393 10.897 5.06393C11.2014 5.06393 11.5019 5.13245 11.7763 5.26441C12.0506 5.39637 12.2918 5.58839 12.4818 5.82623C12.6747 6.06502 12.8095 6.34537 12.8755 6.64515C12.9415 6.94494 12.9369 7.25597 12.8621 7.55369Z"
            fill="white"
        />
    </svg>
)

export const AttachIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = () => (
    <svg
        className="mr-1 cursor-pointer"
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.07132 7.47186L10.3767 8.8218L6.46065 12.8715C6.10027 13.2442 6.10023 13.8489 6.46057 14.2215C6.81981 14.593 7.40648 14.5932 7.76602 14.2214L14.9426 6.7999C16.0279 5.67759 16.028 3.86657 14.9455 2.74711C13.8641 1.62881 12.1099 1.62969 11.0265 2.75011L3.19597 10.8479C1.39606 12.7092 1.3958 15.7336 3.19712 17.5963C4.99988 19.4606 7.921 19.4609 9.72286 17.5975L15.435 11.6904L14.6192 12.5341L15.9246 13.884L17.5569 12.196L11.0282 18.9475C8.50558 21.5562 4.41559 21.5563 1.89174 18.9463C-0.631554 16.3369 -0.629221 12.1038 1.89059 9.49795L8.41921 2.74651L9.72111 1.40018C11.5251 -0.465347 14.4482 -0.467102 16.2509 1.39717C18.0533 3.26104 18.0553 6.28083 16.248 8.14983L9.0714 15.5714C7.98995 16.6897 6.2344 16.6875 5.15518 15.5715C4.07377 14.4531 4.07408 12.6397 5.15527 11.5216L9.07132 7.47186ZM9.39767 7.13438L10.703 8.48431L10.3767 8.8218L9.07132 7.47186L9.39767 7.13438ZM10.3751 6.12358C10.7365 5.7499 11.3191 5.74656 11.6821 6.12193C12.0425 6.49471 12.043 7.09857 11.6805 7.47351L10.703 8.48431L9.39767 7.13438L10.3751 6.12358ZM15.5966 11.5233C15.958 11.1496 16.5406 11.1463 16.9036 11.5217C17.2641 11.8944 17.2646 12.4983 16.902 12.8732L15.9246 13.884L14.6192 12.5341L15.5966 11.5233Z"
            fill="#888888"
        />
    </svg>
)

export const StudentHeaderHome = () => {
    return (
        <svg
            className='mr-3'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M18.3346 16.6672V10.1455C18.3347 9.6918 18.2421 9.24284 18.0626 8.82614C17.883 8.40945 17.6203 8.0338 17.2905 7.7222L11.1463 1.91553C10.8369 1.62297 10.4272 1.45996 10.0013 1.45996C9.57545 1.45996 9.16575 1.62297 8.8563 1.91553L2.71214 7.7222C2.38232 8.0338 2.1196 8.40945 1.94005 8.82614C1.7605 9.24284 1.66792 9.6918 1.66797 10.1455V16.6672C1.66797 17.1092 1.84356 17.5332 2.15612 17.8457C2.46868 18.1583 2.89261 18.3339 3.33464 18.3339H16.668C17.11 18.3339 17.5339 18.1583 17.8465 17.8457C18.159 17.5332 18.3346 17.1092 18.3346 16.6672Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
        </svg>
    )
}

export const StudentHeaderCalender = () => {
    return (
        <svg
            className='mr-3'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M15.0013 3.33301H5.0013C3.16035 3.33301 1.66797 4.82539 1.66797 6.66634V14.9997C1.66797 16.8406 3.16035 18.333 5.0013 18.333H15.0013C16.8423 18.333 18.3346 16.8406 18.3346 14.9997V6.66634C18.3346 4.82539 16.8423 3.33301 15.0013 3.33301Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M6.66797 1.66699V5.00033'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M13.332 1.66699V5.00033'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M1.66797 8.33301H18.3346'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
        </svg>
    )
}
export const StudentHeaderCopyRight = () => {
    return (
        <svg
            className='mr-3'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M8.7487 17.5C4.83668 17.5 1.66536 14.1421 1.66536 10C1.66536 5.85786 4.83668 2.5 8.7487 2.5C12.6607 2.5 15.832 5.85786 15.832 10C15.832 14.1421 12.6607 17.5 8.7487 17.5Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M10.832 7.33366C10.3017 6.90357 9.63988 6.66827 8.95703 6.66699C7.2312 6.66699 5.83203 8.15866 5.83203 10.0003C5.83203 11.842 7.2312 13.3337 8.95703 13.3337C9.66036 13.3337 10.3095 13.0853 10.832 12.667'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M9.16797 2.5C12.2238 2.5 18.3346 3.25 18.3346 10C18.3346 16.75 12.2238 17.5 9.16797 17.5'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
        </svg>
    )
}
export const StudentHeaderRefer = () => {
    return (
        <svg
            className='mr-3'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M15.8333 6.66699H4.16667C3.24619 6.66699 2.5 7.41318 2.5 8.33366V16.667C2.5 17.5875 3.24619 18.3337 4.16667 18.3337H15.8333C16.7538 18.3337 17.5 17.5875 17.5 16.667V8.33366C17.5 7.41318 16.7538 6.66699 15.8333 6.66699Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M10 4.16699C10 3.67254 9.85338 3.18919 9.57867 2.77807C9.30397 2.36694 8.91352 2.04651 8.45671 1.85729C7.99989 1.66808 7.49723 1.61857 7.01228 1.71503C6.52732 1.81149 6.08187 2.0496 5.73223 2.39923C5.3826 2.74886 5.1445 3.19432 5.04804 3.67927C4.95157 4.16422 5.00108 4.66689 5.1903 5.1237C5.37952 5.58052 5.69995 5.97096 6.11108 6.24567C6.5222 6.52037 7.00555 6.66699 7.5 6.66699'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M12.5 6.66699C12.9945 6.66699 13.4778 6.52037 13.8889 6.24567C14.3 5.97096 14.6205 5.58052 14.8097 5.1237C14.9989 4.66689 15.0484 4.16422 14.952 3.67927C14.8555 3.19432 14.6174 2.74886 14.2678 2.39923C13.9181 2.0496 13.4727 1.81149 12.9877 1.71503C12.5028 1.61857 12.0001 1.66808 11.5433 1.85729C11.0865 2.04651 10.696 2.36694 10.4213 2.77807C10.1466 3.18919 10 3.67254 10 4.16699'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M10 4.16699V18.3337'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M17.5 12.5H2.5'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
        </svg>
    )
}
export const StudentHeaderHelpCenter = () => {
    return (
        <svg
            className='mr-3'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.10744 15.8925C7.36181 19.1469 12.6382 19.1469 15.8926 15.8925C19.1469 12.6381 19.1469 7.36177 15.8926 4.1074C12.6382 0.853031 7.36181 0.853031 4.10744 4.1074C0.853074 7.36177 0.853074 12.6381 4.10744 15.8925Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M7.64298 12.357C8.94472 13.6587 11.0553 13.6587 12.357 12.357C13.6588 11.0552 13.6588 8.94466 12.357 7.64291C11.0553 6.34116 8.94473 6.34116 7.64298 7.64291C6.34123 8.94466 6.34123 11.0552 7.64298 12.357Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M15.8913 4.10742L12.3555 7.64325'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M7.64521 12.3567L4.10938 15.8925'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M15.8913 15.8925L12.3555 12.3567'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
            <path
                d='M7.64521 7.64325L4.10938 4.10742'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            ></path>
        </svg>
    )
}
export const StudentHeaderMessage = () => {
    return (
        <svg
            className='mr-3'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.44364 3.60846C5.34517 3.60846 2.83334 6.07564 2.83334 9.11909C2.83334 12.1625 5.34517 14.6297 8.44364 14.6297H11.1717C11.2949 14.6297 11.4171 14.6258 11.5381 14.6181C11.7566 14.6043 11.9778 14.6714 12.1527 14.8152L14.1242 16.4358C14.2143 16.5099 14.3515 16.447 14.3515 16.3316V14.0878C14.3515 13.8229 14.4765 13.5799 14.6781 13.4212C15.9619 12.4102 16.7821 10.8589 16.7821 9.11909C16.7821 6.07564 14.2702 3.60846 11.1717 3.60846H8.44364ZM1.5 9.11909C1.5 5.35235 4.60879 2.29883 8.44364 2.29883H11.1717C15.0066 2.29883 18.1154 5.35235 18.1154 9.11909C18.1154 11.1938 17.1715 13.0524 15.6848 14.3023V17.6041C15.6848 18.3266 14.8261 18.7206 14.2619 18.2569L11.4367 15.9344C11.3488 15.9377 11.2604 15.9393 11.1717 15.9393H8.44364C4.60879 15.9393 1.5 12.8857 1.5 9.11909Z'
                fill='#999A9E'
                stroke='#999A9E'
                strokeWidth='0.8'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.44364 3.60846C5.34517 3.60846 2.83334 6.07564 2.83334 9.11909C2.83334 12.1625 5.34517 14.6297 8.44364 14.6297H11.1717C11.2949 14.6297 11.4171 14.6258 11.5381 14.6181C11.7566 14.6043 11.9778 14.6714 12.1527 14.8152L14.1242 16.4358C14.2143 16.5099 14.3515 16.447 14.3515 16.3316V14.0878C14.3515 13.8229 14.4765 13.5799 14.6781 13.4212C15.9619 12.4102 16.7821 10.8589 16.7821 9.11909C16.7821 6.07564 14.2702 3.60846 11.1717 3.60846H8.44364ZM1.5 9.11909C1.5 5.35235 4.60879 2.29883 8.44364 2.29883H11.1717C15.0066 2.29883 18.1154 5.35235 18.1154 9.11909C18.1154 11.1938 17.1715 13.0524 15.6848 14.3023V17.6041C15.6848 18.3266 14.8261 18.7206 14.2619 18.2569L11.4367 15.9344C11.3488 15.9377 11.2604 15.9393 11.1717 15.9393H8.44364C4.60879 15.9393 1.5 12.8857 1.5 9.11909Z'
                fill='#999A9E'
                stroke='#999A9E'
                strokeWidth='0.8'
            />
        </svg>
    )
}
export const StudentHeaderBellIcon = () => {
    return (
        <svg
            className='mr-3'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.4024 15.9898H4.6019C4.33642 16.001 4.07139 15.9585 3.82199 15.8647C3.5726 15.771 3.34372 15.6278 3.14848 15.4435C2.95324 15.2591 2.79547 15.0371 2.68419 14.7903C2.57291 14.5435 2.51032 14.2766 2.5 14.005C2.51575 13.2161 2.75996 12.4498 3.20171 11.8031C3.92993 10.6189 4.27293 9.22923 4.18152 7.83333C4.18152 3.27936 6.25109 0.772461 10.0022 0.772461C13.7533 0.772461 15.8228 3.27936 15.8228 7.83531C15.7314 9.23122 16.0744 10.6209 16.8026 11.8051C17.244 12.4513 17.4882 13.2168 17.5043 14.005C17.494 14.2766 17.4314 14.5435 17.3202 14.7903C17.2089 15.0371 17.0511 15.2591 16.8559 15.4435C16.6606 15.6278 16.4318 15.771 16.1824 15.8647C15.933 15.9585 15.6679 16.001 15.4024 15.9898ZM10.0022 2.09571C6.99807 2.09571 5.475 4.027 5.475 7.83531C5.56453 9.46733 5.15981 11.0879 4.31604 12.476C3.99396 12.9194 3.81167 13.4528 3.79348 14.005C3.79348 14.5495 4.44022 14.6666 4.6019 14.6666H15.4024C15.5628 14.6666 16.2109 14.5495 16.2109 14.005C16.1928 13.4526 16.0105 12.919 15.6883 12.4753C14.8447 11.0874 14.44 9.46711 14.5293 7.83531C14.5293 4.027 13.0063 2.09571 10.0022 2.09571Z'
                fill='#999A9E'
                stroke='#999A9E'
            />
            <path
                d='M10.0048 19.0118C9.37871 19.0109 8.77852 18.756 8.33587 18.3031C7.89321 17.8501 7.64424 17.236 7.64356 16.5955C7.64331 16.4445 7.65761 16.2938 7.68624 16.1456C7.70297 16.0604 7.73594 15.9794 7.78327 15.9073C7.8306 15.8351 7.89135 15.7732 7.96207 15.7251C8.03278 15.6769 8.11207 15.6435 8.19541 15.6267C8.27875 15.6099 8.3645 15.6101 8.44778 15.6272C8.53105 15.6443 8.61022 15.6781 8.68075 15.7265C8.75128 15.7749 8.8118 15.8371 8.85886 15.9094C8.90591 15.9817 8.93858 16.0629 8.95499 16.1481C8.9714 16.2334 8.97123 16.3211 8.9545 16.4063C8.94245 16.4686 8.9366 16.532 8.93704 16.5955C8.93205 16.7421 8.95596 16.8882 9.00734 17.0251C9.05872 17.162 9.13652 17.2869 9.23611 17.3924C9.33569 17.4979 9.45502 17.5817 9.58697 17.639C9.71893 17.6963 9.86081 17.7259 10.0042 17.7259C10.1475 17.7259 10.2894 17.6963 10.4213 17.639C10.5533 17.5817 10.6726 17.4979 10.7722 17.3924C10.8718 17.2869 10.9496 17.162 11.001 17.0251C11.0524 16.8882 11.0763 16.7421 11.0713 16.5955C11.0717 16.532 11.0659 16.4686 11.0538 16.4063C11.0371 16.3211 11.0369 16.2334 11.0533 16.1481C11.0697 16.0629 11.1024 15.9817 11.1495 15.9094C11.1965 15.8371 11.257 15.7749 11.3276 15.7265C11.3981 15.6781 11.4773 15.6443 11.5605 15.6272C11.6438 15.6101 11.7296 15.6099 11.8129 15.6267C11.8962 15.6435 11.9755 15.6769 12.0462 15.7251C12.117 15.7732 12.1777 15.8351 12.225 15.9073C12.2724 15.9794 12.3053 16.0604 12.3221 16.1456C12.3507 16.2938 12.365 16.4445 12.3648 16.5955C12.3641 17.2358 12.1153 17.8497 11.6729 18.3026C11.2305 18.7555 10.6307 19.0105 10.0048 19.0118Z'
                fill='#999A9E'
                stroke='#999A9E'
                strokeWidth='0.8'
            />
        </svg>
    )
}
export const StudentHeaderNotificationCount = () => {
    return (
        <svg
            className='relative -pl-1 cursor-pointer'
            xmlns='http://www.w3.org/2000/svg'
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
        >
            <g clipPath='url(#clip0)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18.5226 11.622C14.6308 11.622 11.4759 14.7769 11.4759 18.6688C11.4759 22.5607 14.6308 25.7156 18.5226 25.7156H21.9492C22.1039 25.7156 22.2574 25.7107 22.4094 25.7008C22.6838 25.6832 22.9617 25.769 23.1813 25.9528L25.6576 28.0253C25.7708 28.12 25.9431 28.0395 25.9431 27.892V25.0227C25.9431 24.684 26.1001 24.3732 26.3533 24.1702C27.9658 22.8773 28.996 20.8937 28.996 18.6688C28.996 14.7769 25.8411 11.622 21.9492 11.622H18.5226ZM9.80115 18.6688C9.80115 13.852 13.7059 9.94727 18.5226 9.94727H21.9492C26.7659 9.94727 30.6707 13.852 30.6707 18.6688C30.6707 21.3219 29.4851 23.6987 27.6178 25.297V29.5192C27.6178 30.4432 26.5392 30.947 25.8306 30.354L22.282 27.384C22.1716 27.3882 22.0606 27.3903 21.9492 27.3903H18.5226C13.7059 27.3903 9.80115 23.4855 9.80115 18.6688Z'
                    fill='#321A50'
                    stroke='#321A50'
                    strokeWidth='0.8'
                />
            </g>
            <defs>
                <clipPath id='clip0'>
                    <rect
                        width='22.6087'
                        height='21.7391'
                        fill='white'
                        transform='translate(8.69568 9.56543)'
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
export const StudentHeaderCloseHamburger = () => {
    return (
        <svg
            className='w-6 h-6'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M6 18L18 6M6 6l12 12'
            ></path>
        </svg>
    )
}
export const StudentHeaderBreadcrumb = () => {
    return (
        <svg
            className='hover:none'
            width='8'
            height='13'
            viewBox='0 0 8 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 12L7 6.5L1 1'
                stroke='#7D4AC3'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export const StudentHeaderNotificationUnread = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3512 20.3879H6.6447C6.33237 20.4008 6.02057 20.3519 5.72716 20.2441C5.43375 20.1362 5.16449 19.9716 4.93479 19.7596C4.7051 19.5476 4.51948 19.2923 4.38857 19.0084C4.25766 18.7246 4.18402 18.4177 4.17188 18.1053C4.1904 17.1982 4.47771 16.3169 4.99742 15.5732C5.85415 14.2113 6.25768 12.6132 6.15014 11.0079C6.15014 5.77087 8.58492 2.88794 12.998 2.88794C17.411 2.88794 19.8458 5.77087 19.8458 11.0102C19.7382 12.6155 20.1418 14.2136 20.9985 15.5754C21.5178 16.3186 21.8051 17.199 21.8241 18.1053C21.8119 18.4177 21.7383 18.7246 21.6074 19.0084C21.4764 19.2923 21.2908 19.5476 21.0611 19.7596C20.8314 19.9716 20.5622 20.1362 20.2688 20.2441C19.9754 20.3519 19.6636 20.4008 19.3512 20.3879ZM12.998 4.40968C9.46372 4.40968 7.67188 6.63066 7.67188 11.0102C7.7772 12.887 7.30107 14.7507 6.3084 16.347C5.92948 16.857 5.71502 17.4703 5.69361 18.1053C5.69361 18.7315 6.45448 18.8662 6.6447 18.8662H19.3512C19.5399 18.8662 20.3023 18.7315 20.3023 18.1053C20.2811 17.4701 20.0666 16.8564 19.6875 16.3462C18.695 14.7501 18.2189 12.8868 18.324 11.0102C18.324 6.63066 16.5322 4.40968 12.998 4.40968Z" fill="#321A50" stroke="#321A50" />
            <path d="M13.0006 23.8634C12.264 23.8624 11.5579 23.5693 11.0371 23.0484C10.5164 22.5275 10.2235 21.8213 10.2227 21.0847C10.2224 20.911 10.2392 20.7377 10.2729 20.5674C10.2926 20.4694 10.3313 20.3762 10.387 20.2933C10.4427 20.2103 10.5142 20.1391 10.5974 20.0837C10.6806 20.0284 10.7739 19.9899 10.8719 19.9706C10.9699 19.9513 11.0708 19.9515 11.1688 19.9712C11.2668 19.9909 11.3599 20.0297 11.4429 20.0854C11.5259 20.141 11.5971 20.2125 11.6524 20.2957C11.7078 20.3789 11.7462 20.4722 11.7655 20.5702C11.7848 20.6683 11.7846 20.7692 11.7649 20.8671C11.7508 20.9388 11.7439 21.0117 11.7444 21.0847C11.7385 21.2533 11.7667 21.4213 11.8271 21.5787C11.8876 21.7362 11.9791 21.8798 12.0962 22.0011C12.2134 22.1224 12.3538 22.2189 12.509 22.2848C12.6643 22.3507 12.8312 22.3847 12.9998 22.3847C13.1685 22.3847 13.3354 22.3507 13.4906 22.2848C13.6459 22.2189 13.7863 22.1224 13.9034 22.0011C14.0206 21.8798 14.1121 21.7362 14.1726 21.5787C14.233 21.4213 14.2611 21.2533 14.2553 21.0847C14.2558 21.0117 14.2489 20.9388 14.2347 20.8671C14.215 20.7692 14.2148 20.6683 14.2342 20.5702C14.2535 20.4722 14.2919 20.3789 14.3472 20.2957C14.4026 20.2125 14.4738 20.141 14.5568 20.0854C14.6398 20.0297 14.7329 19.9909 14.8309 19.9712C14.9288 19.9515 15.0297 19.9513 15.1278 19.9706C15.2258 19.9899 15.3191 20.0284 15.4023 20.0837C15.4855 20.1391 15.557 20.2103 15.6126 20.2933C15.6683 20.3762 15.7071 20.4694 15.7268 20.5674C15.7605 20.7377 15.7773 20.911 15.777 21.0847C15.7762 21.8211 15.4835 22.527 14.9631 23.0479C14.4426 23.5688 13.7369 23.862 13.0006 23.8634Z" fill="#321A50" stroke="#321A50" strokeWidth="0.8" />
        </svg>
    )
}


interface IMoreOptionsProps extends SVGProps<SVGSVGElement> {
    showGroupOptions?: boolean;
}

export const MoreOptions = (props: IMoreOptionsProps) => {
    return (
        <svg
            className={`${props.showGroupOptions ? 'rotate-channel-list-img' : ''}`}
            width="15"
            height="10"
            viewBox="0 0 16 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.42822 2.92822L7.99965 8.49965L13.5711 2.92822"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
export const ViewProfileSvg = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10 17.7188C11.3551 17.7207 12.6865 17.3643 13.8594 16.6856V14.1562C13.8594 13.4476 13.5779 12.768 13.0768 12.2669C12.5757 11.7659 11.8961 11.4844 11.1875 11.4844H8.8125C8.10387 11.4844 7.42427 11.7659 6.9232 12.2669C6.42213 12.768 6.14063 13.4476 6.14062 14.1562V16.6856C7.31347 17.3643 8.64495 17.7207 10 17.7188V17.7188ZM15.6406 14.1562V15.2689C16.6675 14.1697 17.3507 12.7943 17.6064 11.312C17.8621 9.82963 17.6791 8.30486 17.0799 6.92512C16.4806 5.54537 15.4913 4.37079 14.2335 3.54575C12.9757 2.72071 11.5042 2.28118 10 2.28118C8.49575 2.28118 7.02428 2.72071 5.76648 3.54575C4.50867 4.37079 3.51935 5.54537 2.92012 6.92512C2.3209 8.30486 2.13788 9.82963 2.39358 11.312C2.64928 12.7943 3.33254 14.1697 4.35938 15.2689V14.1562C4.35937 13.2382 4.64297 12.3425 5.17139 11.5917C5.69981 10.841 6.44726 10.2718 7.3115 9.962C6.86308 9.44622 6.57249 8.81235 6.47439 8.13598C6.37629 7.45961 6.47481 6.7693 6.75821 6.14738C7.04162 5.52546 7.49793 4.99818 8.07273 4.62844C8.64753 4.25871 9.31655 4.06211 10 4.06211C10.6834 4.06211 11.3525 4.25871 11.9273 4.62844C12.5021 4.99818 12.9584 5.52546 13.2418 6.14738C13.5252 6.7693 13.6237 7.45961 13.5256 8.13598C13.4275 8.81235 13.1369 9.44622 12.6885 9.962C13.5527 10.2718 14.3002 10.841 14.8286 11.5917C15.357 12.3425 15.6406 13.2382 15.6406 14.1562V14.1562ZM10 19.5C12.5196 19.5 14.9359 18.4991 16.7175 16.7175C18.4991 14.9359 19.5 12.5196 19.5 10C19.5 7.48044 18.4991 5.06408 16.7175 3.28249C14.9359 1.50089 12.5196 0.5 10 0.5C7.48044 0.5 5.06408 1.50089 3.28249 3.28249C1.50089 5.06408 0.5 7.48044 0.5 10C0.5 12.5196 1.50089 14.9359 3.28249 16.7175C5.06408 18.4991 7.48044 19.5 10 19.5V19.5ZM11.7812 7.625C11.7812 8.09742 11.5936 8.55049 11.2595 8.88453C10.9255 9.21858 10.4724 9.40625 10 9.40625C9.52758 9.40625 9.07451 9.21858 8.74047 8.88453C8.40642 8.55049 8.21875 8.09742 8.21875 7.625C8.21875 7.15258 8.40642 6.69951 8.74047 6.36547C9.07451 6.03142 9.52758 5.84375 10 5.84375C10.4724 5.84375 10.9255 6.03142 11.2595 6.36547C11.5936 6.69951 11.7812 7.15258 11.7812 7.625V7.625Z'
            fill='black'
        />
    </svg>
);

export const PhoneCallReminderIcon = () => (
    <svg width='15' height='15' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11.7892 2.52648C11.8132 2.43482 11.8552 2.34887 11.9129 2.27366C11.9705 2.19845 12.0426 2.13549 12.1248 2.08848C12.2071 2.04147 12.2979 2.01136 12.392 1.99989C12.486 1.98843 12.5814 1.99585 12.6726 2.02173C14.0168 2.38224 15.2424 3.09009 16.2265 4.07418C17.2106 5.05826 17.9185 6.28395 18.279 7.62816C18.3049 7.7193 18.3123 7.8147 18.3008 7.90875C18.2894 8.0028 18.2592 8.09362 18.2122 8.17589C18.1652 8.25815 18.1023 8.33021 18.027 8.38784C17.9518 8.44546 17.8659 8.4875 17.7742 8.51148C17.7127 8.5293 17.649 8.5384 17.5849 8.53852C17.4258 8.53761 17.2714 8.48407 17.1459 8.38624C17.0203 8.28842 16.9307 8.15181 16.8909 7.99771C16.591 6.90012 16.0102 5.89968 15.2056 5.09511C14.401 4.29055 13.4006 3.70968 12.303 3.40981C12.2105 3.38682 12.1236 3.34549 12.0474 3.28829C11.9712 3.23109 11.9072 3.15917 11.8593 3.0768C11.8114 2.99443 11.7805 2.90328 11.7685 2.80875C11.7564 2.71422 11.7635 2.61824 11.7892 2.52648ZM11.5549 6.195C12.165 6.36201 12.7211 6.68507 13.1684 7.13235C13.6156 7.57964 13.9387 8.13572 14.1057 8.74584C14.1441 8.9007 14.2333 9.0382 14.3592 9.13627C14.4851 9.23433 14.6402 9.28729 14.7997 9.28665C14.8609 9.28725 14.9217 9.27812 14.98 9.25961C15.0725 9.23661 15.1594 9.19529 15.2356 9.13809C15.3118 9.08088 15.3758 9.00897 15.4237 8.92659C15.4716 8.84422 15.5025 8.75307 15.5145 8.65854C15.5266 8.56401 15.5195 8.46803 15.4938 8.37628C15.2662 7.51955 14.8161 6.7382 14.1893 6.11138C13.5625 5.48457 12.7812 5.03455 11.9244 4.80691C11.8304 4.77265 11.7302 4.75834 11.6303 4.76491C11.5304 4.77147 11.433 4.79876 11.3442 4.84504C11.2555 4.89133 11.1773 4.95558 11.1147 5.03373C11.0522 5.11187 11.0065 5.20219 10.9808 5.29892C10.955 5.39566 10.9497 5.4967 10.9651 5.59561C10.9806 5.69452 11.0164 5.78913 11.0704 5.87343C11.1244 5.95772 11.1954 6.02984 11.2788 6.08521C11.3622 6.14057 11.4562 6.17796 11.5549 6.195ZM18.9911 14.8931C18.8316 16.1103 18.2356 17.2282 17.3138 18.0389C16.392 18.8496 15.2071 19.298 13.9795 19.3007C6.82275 19.3007 1 13.478 1 6.32119C1.00271 5.0936 1.4511 3.90875 2.26183 2.98695C3.07255 2.06515 4.19043 1.46911 5.40763 1.30966C5.71791 1.27525 6.0311 1.34058 6.30175 1.49617C6.57241 1.65175 6.78647 1.88951 6.91289 2.17496L8.72461 6.40231C8.81859 6.62174 8.85627 6.86116 8.83423 7.09885C8.8122 7.33653 8.73114 7.56495 8.59842 7.76336L7.10217 10.0528C7.77971 11.4278 8.8961 12.5379 10.2749 13.2075L12.5373 11.7023C12.7355 11.5687 12.9645 11.4878 13.2027 11.4673C13.4408 11.4468 13.6803 11.4873 13.8984 11.5851L18.1257 13.3878C18.4112 13.5142 18.649 13.7283 18.8045 13.999C18.9601 14.2696 19.0255 14.5828 18.9911 14.8931ZM17.5579 14.7128L13.3305 12.9101L11.0772 14.4154C10.8698 14.5524 10.6306 14.6336 10.3826 14.651C10.1347 14.6683 9.88645 14.6213 9.66202 14.5145C7.98275 13.7022 6.62439 12.3502 5.80422 10.6747C5.69609 10.4511 5.64756 10.2033 5.66335 9.95533C5.67915 9.7074 5.75872 9.46775 5.89436 9.25961L7.39962 6.97017L5.5879 2.74281C4.71805 2.85463 3.91877 3.27967 3.33973 3.93835C2.76069 4.59703 2.44159 5.44418 2.44217 6.32119C2.44456 9.38035 3.66086 12.3135 5.82402 14.4767C7.98717 16.6398 10.9204 17.8561 13.9795 17.8585C14.8565 17.8591 15.7037 17.54 16.3624 16.961C17.021 16.3819 17.4461 15.5827 17.5579 14.7128Z'
            fill='#1b2437'
            stroke='#1b2437'
            strokeWidth='0.6'
        />
    </svg>
);

export const EmailIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <path d="M4.80523 14.0264C3.94636 14.0264 3.24756 13.3277 3.24756 12.4688V6.50681C3.24756 5.64793 3.94636 4.94922 4.80523 4.94922H14.33C15.1888 4.94922 15.8875 5.64793 15.8875 6.50681V12.4688C15.8875 13.3277 15.1888 14.0264 14.33 14.0264H4.80523ZM4.80523 5.60826C4.30964 5.60826 3.90651 6.01139 3.90651 6.50681V12.4688C3.90651 12.9643 4.30964 13.3675 4.80523 13.3675H14.33C14.8254 13.3675 15.2285 12.9643 15.2285 12.4688V6.50681C15.2285 6.0113 14.8254 5.60826 14.33 5.60826H4.80523Z" fill="black" stroke="black" strokeWidth="0.71875" />
        <path d="M9.56729 10.5138C9.13828 10.5138 8.73558 10.3644 8.43345 10.0931L3.76318 5.89951L4.20332 5.40918L8.87375 9.60265C9.056 9.76627 9.30233 9.8564 9.56738 9.8564C9.83242 9.8564 10.0788 9.76627 10.2611 9.60265L14.9307 5.40918L15.3711 5.89951L10.7013 10.0931C10.3991 10.3643 9.99638 10.5138 9.56729 10.5138Z" fill="black" stroke="black" strokeWidth="0.71875" />
    </svg>
)

export const NotificationIcon = () => (
    <svg width='24' height='23' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M15.4024 15.9898H4.6019C4.33642 16.001 4.07139 15.9585 3.82199 15.8647C3.5726 15.771 3.34372 15.6278 3.14848 15.4435C2.95324 15.2591 2.79547 15.0371 2.68419 14.7903C2.57291 14.5435 2.51032 14.2766 2.5 14.005C2.51575 13.2161 2.75996 12.4498 3.20171 11.8031C3.92993 10.6189 4.27293 9.22923 4.18152 7.83333C4.18152 3.27936 6.25109 0.772461 10.0022 0.772461C13.7533 0.772461 15.8228 3.27936 15.8228 7.83531C15.7314 9.23122 16.0744 10.6209 16.8026 11.8051C17.244 12.4513 17.4882 13.2168 17.5043 14.005C17.494 14.2766 17.4314 14.5435 17.3202 14.7903C17.2089 15.0371 17.0511 15.2591 16.8559 15.4435C16.6606 15.6278 16.4318 15.771 16.1824 15.8647C15.933 15.9585 15.6679 16.001 15.4024 15.9898ZM10.0022 2.09571C6.99807 2.09571 5.475 4.027 5.475 7.83531C5.56453 9.46733 5.15981 11.0879 4.31604 12.476C3.99396 12.9194 3.81167 13.4528 3.79348 14.005C3.79348 14.5495 4.44022 14.6666 4.6019 14.6666H15.4024C15.5628 14.6666 16.2109 14.5495 16.2109 14.005C16.1928 13.4526 16.0105 12.919 15.6883 12.4753C14.8447 11.0874 14.44 9.46711 14.5293 7.83531C14.5293 4.027 13.0063 2.09571 10.0022 2.09571Z'
            fill='#999A9E'
            stroke='#999A9E'
        />
        <path
            d='M10.0048 19.0118C9.37871 19.0109 8.77852 18.756 8.33587 18.3031C7.89321 17.8501 7.64424 17.236 7.64356 16.5955C7.64331 16.4445 7.65761 16.2938 7.68624 16.1456C7.70297 16.0604 7.73594 15.9794 7.78327 15.9073C7.8306 15.8351 7.89135 15.7732 7.96207 15.7251C8.03278 15.6769 8.11207 15.6435 8.19541 15.6267C8.27875 15.6099 8.3645 15.6101 8.44778 15.6272C8.53105 15.6443 8.61022 15.6781 8.68075 15.7265C8.75128 15.7749 8.8118 15.8371 8.85886 15.9094C8.90591 15.9817 8.93858 16.0629 8.95499 16.1481C8.9714 16.2334 8.97123 16.3211 8.9545 16.4063C8.94245 16.4686 8.9366 16.532 8.93704 16.5955C8.93205 16.7421 8.95596 16.8882 9.00734 17.0251C9.05872 17.162 9.13652 17.2869 9.23611 17.3924C9.33569 17.4979 9.45502 17.5817 9.58697 17.639C9.71893 17.6963 9.86081 17.7259 10.0042 17.7259C10.1475 17.7259 10.2894 17.6963 10.4213 17.639C10.5533 17.5817 10.6726 17.4979 10.7722 17.3924C10.8718 17.2869 10.9496 17.162 11.001 17.0251C11.0524 16.8882 11.0763 16.7421 11.0713 16.5955C11.0717 16.532 11.0659 16.4686 11.0538 16.4063C11.0371 16.3211 11.0369 16.2334 11.0533 16.1481C11.0697 16.0629 11.1024 15.9817 11.1495 15.9094C11.1965 15.8371 11.257 15.7749 11.3276 15.7265C11.3981 15.6781 11.4773 15.6443 11.5605 15.6272C11.6438 15.6101 11.7296 15.6099 11.8129 15.6267C11.8962 15.6435 11.9755 15.6769 12.0462 15.7251C12.117 15.7732 12.1777 15.8351 12.225 15.9073C12.2724 15.9794 12.3053 16.0604 12.3221 16.1456C12.3507 16.2938 12.365 16.4445 12.3648 16.5955C12.3641 17.2358 12.1153 17.8497 11.6729 18.3026C11.2305 18.7555 10.6307 19.0105 10.0048 19.0118Z'
            fill='#999A9E'
            stroke='#999A9E'
            strokeWidth='0.8'
        />
    </svg>
);

export const AvailabilityIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_5592_40398)'>
            <path
                d='M15.0013 3.3335H5.0013C3.16035 3.3335 1.66797 4.82588 1.66797 6.66683V15.0002C1.66797 16.8411 3.16035 18.3335 5.0013 18.3335H15.0013C16.8423 18.3335 18.3346 16.8411 18.3346 15.0002V6.66683C18.3346 4.82588 16.8423 3.3335 15.0013 3.3335Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.66797 1.6665V4.99984'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.332 1.6665V4.99984'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                className='AvailabilityIconTickMark'
                d='M14.824 9.15894C14.8267 9.46548 14.7089 9.7608 14.4959 9.98129L9.8195 14.6577C9.60026 14.8769 9.30295 15 8.99294 15C8.68294 15 8.38563 14.8769 8.16639 14.6577L5.82818 12.3195C5.61522 12.099 5.49738 11.8037 5.50004 11.4971C5.50271 11.1906 5.62566 10.8974 5.84242 10.6806C6.05918 10.4639 6.35241 10.3409 6.65894 10.3382C6.96548 10.3356 7.2608 10.4534 7.48129 10.6664L8.99294 12.178L12.8428 8.32818C13.0633 8.11522 13.3586 7.99738 13.6651 8.00004C13.9717 8.00271 14.2649 8.12566 14.4817 8.34242C14.6984 8.55918 14.8214 8.85241 14.824 9.15894Z'
                fill='#999A9E'
            />
        </g>
        <defs>
            <clipPath id='clip0_5592_40398'>
                <rect width='20' height='20' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const MySessionsIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_5492_4718)'>
            <path
                d='M15.0013 3.3335H5.0013C3.16035 3.3335 1.66797 4.82588 1.66797 6.66683V15.0002C1.66797 16.8411 3.16035 18.3335 5.0013 18.3335H15.0013C16.8423 18.3335 18.3346 16.8411 18.3346 15.0002V6.66683C18.3346 4.82588 16.8423 3.3335 15.0013 3.3335Z'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.66797 1.6665V4.99984'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.332 1.6665V4.99984'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.66797 8.33301H18.3346'
                stroke='#999A9E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_5492_4718'>
                <rect width='20' height='20' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const WorkshopsIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.10744 15.8926C7.36181 19.1469 12.6382 19.1469 15.8926 15.8926C19.1469 12.6382 19.1469 7.36183 15.8926 4.10746C12.6382 0.853092 7.36181 0.853092 4.10744 4.10746C0.853074 7.36183 0.853074 12.6382 4.10744 15.8926Z'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.64298 12.3573C8.94472 13.659 11.0553 13.659 12.357 12.3573C13.6588 11.0555 13.6588 8.94496 12.357 7.64322C11.0553 6.34147 8.94473 6.34147 7.64298 7.64322C6.34123 8.94496 6.34123 11.0555 7.64298 12.3573Z'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M15.8913 4.10748L12.3555 7.64332'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.64521 12.3565L4.10938 15.8923'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M15.8913 15.8923L12.3555 12.3565'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.64521 7.64332L4.10938 4.10748'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const AnnouncementsIcon = () => (
    <svg width='20' height='19' viewBox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.9999 2.74141V6.00041C17.3939 6.00041 17.784 6.078 18.148 6.22877C18.512 6.37953 18.8427 6.60051 19.1213 6.87909C19.3998 7.15766 19.6208 7.48838 19.7716 7.85236C19.9223 8.21633 19.9999 8.60644 19.9999 9.00041C19.9999 9.39437 19.9223 9.78448 19.7716 10.1485C19.6208 10.5124 19.3998 10.8432 19.1213 11.1217C18.8427 11.4003 18.512 11.6213 18.148 11.772C17.784 11.9228 17.3939 12.0004 16.9999 12.0004V15.0004C16.9999 16.6484 15.1189 17.5894 13.7999 16.6004L11.7399 15.0544C10.6388 14.2288 9.35668 13.6775 7.99993 13.4464V16.2904C8.00004 16.9442 7.76382 17.5759 7.33483 18.0692C6.90584 18.5625 6.31298 18.8841 5.66555 18.9747C5.01811 19.0653 4.35975 18.9188 3.81181 18.5623C3.26387 18.2057 2.8633 17.6631 2.68393 17.0344L1.11393 11.5384C0.548949 10.8712 0.181268 10.0596 0.0522177 9.19491C-0.0768324 8.33021 0.0378643 7.44664 0.383415 6.64354C0.728966 5.84044 1.29167 5.14965 2.00828 4.6488C2.72489 4.14796 3.56699 3.85692 4.43993 3.80841L7.45793 3.64041C8.93455 3.55823 10.3706 3.12674 11.6479 2.38141L13.9919 1.01341C15.3259 0.236406 16.9999 1.19741 16.9999 2.74141ZM3.63393 13.0784L4.60693 16.4854C4.65376 16.6503 4.75867 16.7927 4.9023 16.8863C5.04594 16.9799 5.21858 17.0184 5.38836 16.9946C5.55814 16.9708 5.71359 16.8865 5.826 16.757C5.93841 16.6276 6.00019 16.4618 5.99993 16.2904V13.2804L4.43993 13.1934C4.16845 13.1783 3.89879 13.1399 3.63393 13.0784ZM14.9999 2.74141L12.6549 4.11041C11.2303 4.94085 9.64175 5.45069 7.99993 5.60441V11.4234C9.78693 11.6694 11.4879 12.3664 12.9399 13.4544L14.9999 15.0004V2.74141ZM5.99993 5.72441L4.54993 5.80441C3.87538 5.84165 3.2393 6.13043 2.76725 6.61373C2.2952 7.09703 2.02148 7.73973 2.00013 8.41498C1.97879 9.09022 2.21135 9.74894 2.65193 10.2611C3.09251 10.7732 3.70908 11.1016 4.37993 11.1814L4.54993 11.1964L5.99993 11.2764V5.72441ZM16.9999 8.00041V10.0004C17.2548 10.0001 17.5 9.90253 17.6853 9.72756C17.8706 9.55259 17.9822 9.31345 17.9971 9.05901C18.012 8.80457 17.9293 8.55403 17.7657 8.35857C17.6021 8.16312 17.37 8.03751 17.1169 8.00741L16.9999 8.00041Z'
            fill='#999A9E'
        />
    </svg>
);
export const TestYourSetupIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.72727 17.4091V18.2727H13.3636V17.4091H4.72727ZM4.72727 3.59091H13.3636V2.72727H4.72727V3.59091ZM4.72727 20C4.25227 20 3.84579 19.831 3.50782 19.493C3.16927 19.1545 3 18.7477 3 18.2727V2.72727C3 2.25227 3.16927 1.8455 3.50782 1.50695C3.84579 1.16898 4.25227 1 4.72727 1H13.3636C13.8386 1 14.2454 1.16898 14.584 1.50695C14.9219 1.8455 15.0909 2.25227 15.0909 2.72727V6.18182H13.3636V5.31818H4.72727V15.6818H13.3636V14.8182H15.0909V18.2727C15.0909 18.7477 14.9219 19.1545 14.584 19.493C14.2454 19.831 13.8386 20 13.3636 20H4.72727ZM13.7523 13.9545C13.6371 13.9545 13.5401 13.9186 13.4612 13.8466C13.3818 13.7746 13.3348 13.6811 13.3205 13.5659L13.2341 12.875C13.1189 12.8318 13.0182 12.7849 12.9318 12.7342C12.8455 12.6841 12.7591 12.6159 12.6727 12.5295L12.025 12.8102C11.9242 12.8534 11.8235 12.8572 11.7227 12.8215C11.622 12.7852 11.5428 12.7167 11.4852 12.6159L11.0102 11.7739C10.9527 11.6731 10.9348 11.5723 10.9567 11.4716C10.978 11.3708 11.0318 11.2845 11.1182 11.2125L11.6795 10.8023C11.6508 10.6871 11.6364 10.5792 11.6364 10.4784C11.6364 10.3777 11.6508 10.2697 11.6795 10.1545L11.1398 9.74432C11.0534 9.67235 10.9996 9.58224 10.9783 9.474C10.9564 9.36633 10.9742 9.26212 11.0318 9.16136L11.5284 8.34091C11.586 8.25455 11.6652 8.19323 11.7659 8.15695C11.8667 8.12126 11.9674 8.125 12.0682 8.16818L12.6727 8.42727C12.7591 8.3553 12.8455 8.29773 12.9318 8.25455C13.0182 8.21136 13.1189 8.16818 13.2341 8.125L13.3205 7.43409C13.3348 7.31894 13.3818 7.22538 13.4612 7.15341C13.5401 7.08144 13.6371 7.04545 13.7523 7.04545H14.7023C14.8174 7.04545 14.9147 7.08144 14.9942 7.15341C15.0731 7.22538 15.1197 7.31894 15.1341 7.43409L15.2205 8.125C15.3356 8.16818 15.4364 8.21136 15.5227 8.25455C15.6091 8.29773 15.6955 8.3553 15.7818 8.42727L16.3864 8.16818C16.4871 8.125 16.5879 8.12126 16.6886 8.15695C16.7894 8.19323 16.8686 8.25455 16.9261 8.34091L17.4227 9.16136C17.4803 9.26212 17.4984 9.36633 17.4771 9.474C17.4553 9.58224 17.4011 9.67235 17.3148 9.74432L16.775 10.1545C16.8038 10.2697 16.8182 10.3777 16.8182 10.4784C16.8182 10.5792 16.8038 10.6871 16.775 10.8023L17.3364 11.2125C17.4227 11.2845 17.4768 11.3708 17.4987 11.4716C17.52 11.5723 17.5019 11.6731 17.4443 11.7739L16.9693 12.6159C16.9117 12.7167 16.8326 12.7852 16.7318 12.8215C16.6311 12.8572 16.5303 12.8534 16.4295 12.8102L15.7818 12.5295C15.6955 12.6159 15.6091 12.6841 15.5227 12.7342C15.4364 12.7849 15.3356 12.8318 15.2205 12.875L15.1341 13.5659C15.1197 13.6811 15.0731 13.7746 14.9942 13.8466C14.9147 13.9186 14.8174 13.9545 14.7023 13.9545H13.7523ZM14.2273 11.7955C14.6015 11.7955 14.911 11.6731 15.1557 11.4284C15.4004 11.1837 15.5227 10.8742 15.5227 10.5C15.5227 10.1258 15.4004 9.81629 15.1557 9.57159C14.911 9.32689 14.6015 9.20455 14.2273 9.20455C13.853 9.20455 13.5436 9.32689 13.2989 9.57159C13.0542 9.81629 12.9318 10.1258 12.9318 10.5C12.9318 10.8742 13.0542 11.1837 13.2989 11.4284C13.5436 11.6731 13.853 11.7955 14.2273 11.7955Z'
            fill='#999A9E'
        />
    </svg>
);

export const LogoutIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M3 19C2.45 19 1.979 18.8043 1.587 18.413C1.19567 18.021 1 17.55 1 17V3C1 2.45 1.19567 1.979 1.587 1.587C1.979 1.19567 2.45 1 3 1H10V3H3V17H10V19H3ZM14 15L12.625 13.55L15.175 11H7V9H15.175L12.625 6.45L14 5L19 10L14 15Z'
            fill='#999A9E'
        />
    </svg>
);
export const HomeIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M18.3346 16.6667V10.145C18.3347 9.69131 18.2421 9.24235 18.0626 8.82566C17.883 8.40896 17.6203 8.03331 17.2905 7.72171L11.1463 1.91504C10.8369 1.62248 10.4272 1.45947 10.0013 1.45947C9.57545 1.45947 9.16575 1.62248 8.8563 1.91504L2.71214 7.72171C2.38232 8.03331 2.1196 8.40896 1.94005 8.82566C1.7605 9.24235 1.66792 9.69131 1.66797 10.145V16.6667C1.66797 17.1087 1.84356 17.5327 2.15612 17.8452C2.46868 18.1578 2.89261 18.3334 3.33464 18.3334H16.668C17.11 18.3334 17.5339 18.1578 17.8465 17.8452C18.159 17.5327 18.3346 17.1087 18.3346 16.6667Z'
            stroke='#999A9E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const MenuTab = () => (
    <svg width='26' height='16' viewBox='0 0 26 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='26' height='2' rx='1' fill='#272727' />
        <rect y='7' width='26' height='2' rx='1' fill='#272727' />
        <rect y='14' width='26' height='2' rx='1' fill='#272727' />
    </svg>
);

export const MenuCloseIcon = () => (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_3961_194286)'>
            <path
                d='M12.5 1.5L1.5 12.5'
                stroke='#272727'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.5 1.5L12.5 12.5'
                stroke='#272727'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_3961_194286'>
                <rect width='14' height='14' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const UpDownNavArrow = () => {
    return <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.209605 5.10846L4.90022 0.230403C5.04169 0.083118 5.23701 0 5.44115 0C5.64528 0 5.8406 0.083118 5.98207 0.230403L10.6727 5.10846C10.9601 5.40716 10.9507 5.88241 10.6519 6.16966C10.353 6.45692 9.87791 6.44754 9.59084 6.14884L5.44115 1.83328L1.29145 6.14884C1.0042 6.44772 0.52913 6.45692 0.230432 6.16966C-0.0684544 5.88241 -0.0778356 5.40716 0.209605 5.10846ZM0.209605 11.2707L4.90022 16.1488C5.04169 16.2961 5.23701 16.3792 5.44115 16.3792C5.64528 16.3792 5.8406 16.2961 5.98207 16.1488L10.6727 11.2707C10.9601 10.972 10.9507 10.4968 10.6519 10.2095C10.353 9.92228 9.87791 9.93166 9.59084 10.2304L5.44115 14.5459L1.29145 10.2304C1.0042 9.93147 0.52913 9.92228 0.230432 10.2095C-0.0684544 10.4968 -0.0778356 10.972 0.209605 11.2707Z" fill="#92A1BF" />
    </svg>
}

export const ChatIcon = () => {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9158_28879)">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5227 2.62199C6.63095 2.62199 3.47599 5.77694 3.47599 9.66883C3.47599 13.5607 6.63095 16.7156 10.5227 16.7156H13.9494C14.1041 16.7156 14.2575 16.7107 14.4095 16.7008C14.684 16.6832 14.9618 16.769 15.1814 16.9528L17.6577 19.0253C17.7709 19.12 17.9433 19.0395 17.9433 18.892V16.0227C17.9433 15.684 18.1002 15.3732 18.3534 15.1702C19.966 13.8773 20.9961 11.8937 20.9961 9.66883C20.9961 5.77694 17.8412 2.62199 13.9494 2.62199H10.5227ZM1.80127 9.66883C1.80127 4.85202 5.70603 0.947266 10.5227 0.947266H13.9494C18.7661 0.947266 22.6708 4.85202 22.6708 9.66883C22.6708 12.3219 21.4853 14.6987 19.618 16.297V20.5192C19.618 21.4432 18.5394 21.947 17.8307 21.354L14.2821 18.384C14.1717 18.3882 14.0608 18.3903 13.9494 18.3903H10.5227C5.70603 18.3903 1.80127 14.4855 1.80127 9.66883Z"
                    fill="#999A9E" stroke="#999A9E" strokeWidth="0.8" />
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5227 2.62199C6.63095 2.62199 3.47599 5.77694 3.47599 9.66883C3.47599 13.5607 6.63095 16.7156 10.5227 16.7156H13.9494C14.1041 16.7156 14.2575 16.7107 14.4095 16.7008C14.684 16.6832 14.9618 16.769 15.1814 16.9528L17.6577 19.0253C17.7709 19.12 17.9433 19.0395 17.9433 18.892V16.0227C17.9433 15.684 18.1002 15.3732 18.3534 15.1702C19.966 13.8773 20.9961 11.8937 20.9961 9.66883C20.9961 5.77694 17.8412 2.62199 13.9494 2.62199H10.5227ZM1.80127 9.66883C1.80127 4.85202 5.70603 0.947266 10.5227 0.947266H13.9494C18.7661 0.947266 22.6708 4.85202 22.6708 9.66883C22.6708 12.3219 21.4853 14.6987 19.618 16.297V20.5192C19.618 21.4432 18.5394 21.947 17.8307 21.354L14.2821 18.384C14.1717 18.3882 14.0608 18.3903 13.9494 18.3903H10.5227C5.70603 18.3903 1.80127 14.4855 1.80127 9.66883Z"
                    fill="#999A9E" stroke="#999A9E" strokeWidth="0.8" />
            </g>
            <defs>
                <clipPath id="clip0_9158_28879">
                    <rect width="22.6087" height="21.7391" fill="white" transform="translate(0.695801 0.565186)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const BlackCloseIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="16" fill="black" fillOpacity="0.7" />
            <path d="M20.5 11.5L11.5 20.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 11.5L20.5 20.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export const PrevCarouselIcon = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M14 26.25C10.7511 26.25 7.63526 24.9594 5.33794 22.6621C3.04062 20.3647 1.75 17.2489 1.75 14C1.75 10.7511 3.04062 7.63526 5.33794 5.33794C7.63526 3.04062 10.7511 1.75 14 1.75C17.2489 1.75 20.3647 3.04062 22.6621 5.33794C24.9594 7.63526 26.25 10.7511 26.25 14C26.25 17.2489 24.9594 20.3647 22.6621 22.6621C20.3647 24.9594 17.2489 26.25 14 26.25ZM14 0C10.287 0 6.72601 1.47499 4.1005 4.1005C1.47499 6.72601 0 10.287 0 14C0 17.713 1.47499 21.274 4.1005 23.8995C6.72601 26.525 10.287 28 14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.1005C21.274 1.47499 17.713 0 14 0ZM20.125 13.125C20.3571 13.125 20.5796 13.2172 20.7437 13.3813C20.9078 13.5454 21 13.7679 21 14C21 14.2321 20.9078 14.4546 20.7437 14.6187C20.5796 14.7828 20.3571 14.875 20.125 14.875L9.98725 14.875L13.7445 18.6305C13.9088 18.7948 14.0011 19.0176 14.0011 19.25C14.0011 19.4824 13.9088 19.7052 13.7445 19.8695C13.5802 20.0338 13.3574 20.1261 13.125 20.1261C12.8926 20.1261 12.6698 20.0338 12.5055 19.8695L7.2555 14.6195C7.17402 14.5382 7.10937 14.4417 7.06525 14.3354C7.02114 14.2291 6.99844 14.1151 6.99844 14C6.99844 13.8849 7.02114 13.7709 7.06525 13.6646C7.10937 13.5583 7.17402 13.4618 7.2555 13.3805L12.5055 8.1305C12.6698 7.9662 12.8926 7.8739 13.125 7.8739C13.3574 7.8739 13.5802 7.9662 13.7445 8.1305C13.9088 8.2948 14.0011 8.51764 14.0011 8.75C14.0011 8.98236 13.9088 9.2052 13.7445 9.3695L9.98725 13.125L20.125 13.125Z" fill="white" />
        </svg>

    )
}

export const NextCarouselIcon = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M14 26.25C17.2489 26.25 20.3647 24.9594 22.6621 22.6621C24.9594 20.3647 26.25 17.2489 26.25 14C26.25 10.7511 24.9594 7.63526 22.6621 5.33794C20.3647 3.04062 17.2489 1.75 14 1.75C10.7511 1.75 7.63526 3.04062 5.33794 5.33794C3.04062 7.63526 1.75 10.7511 1.75 14C1.75 17.2489 3.04062 20.3647 5.33794 22.6621C7.63526 24.9594 10.7511 26.25 14 26.25ZM14 0C17.713 0 21.274 1.47499 23.8995 4.1005C26.525 6.72601 28 10.287 28 14C28 17.713 26.525 21.274 23.8995 23.8995C21.274 26.525 17.713 28 14 28C10.287 28 6.72601 26.525 4.10051 23.8995C1.475 21.274 0 17.713 0 14C0 10.287 1.475 6.72601 4.10051 4.1005C6.72601 1.47499 10.287 0 14 0ZM7.875 13.125C7.64294 13.125 7.42038 13.2172 7.25628 13.3813C7.09219 13.5454 7 13.7679 7 14C7 14.2321 7.09219 14.4546 7.25628 14.6187C7.42038 14.7828 7.64294 14.875 7.875 14.875L18.0128 14.875L14.2555 18.6305C14.0912 18.7948 13.9989 19.0176 13.9989 19.25C13.9989 19.4824 14.0912 19.7052 14.2555 19.8695C14.4198 20.0338 14.6426 20.1261 14.875 20.1261C15.1074 20.1261 15.3302 20.0338 15.4945 19.8695L20.7445 14.6195C20.826 14.5382 20.8906 14.4417 20.9347 14.3354C20.9789 14.2291 21.0016 14.1151 21.0016 14C21.0016 13.8849 20.9789 13.7709 20.9347 13.6646C20.8906 13.5583 20.826 13.4618 20.7445 13.3805L15.4945 8.1305C15.3302 7.9662 15.1074 7.8739 14.875 7.8739C14.6426 7.8739 14.4198 7.9662 14.2555 8.1305C14.0912 8.2948 13.9989 8.51764 13.9989 8.75C13.9989 8.98236 14.0912 9.2052 14.2555 9.3695L18.0128 13.125L7.875 13.125Z" fill="white" />
        </svg>
    )
}

export const ChatActiveIcon = () => {
    return (
        <svg className='cursor-pointer' width="26" height="26" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_386_21829)">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5223 2.62199C6.63046 2.62199 3.4755 5.77694 3.4755 9.66883C3.4755 13.5607 6.63046 16.7156 10.5223 16.7156H13.9489C14.1036 16.7156 14.257 16.7107 14.409 16.7008C14.6835 16.6832 14.9613 16.769 15.181 16.9528L17.6572 19.0253C17.7704 19.12 17.9428 19.0395 17.9428 18.892V16.0227C17.9428 15.684 18.0997 15.3732 18.353 15.1702C19.9655 13.8773 20.9957 11.8937 20.9957 9.66883C20.9957 5.77694 17.8407 2.62199 13.9489 2.62199H10.5223ZM1.80078 9.66883C1.80078 4.85202 5.70554 0.947266 10.5223 0.947266H13.9489C18.7656 0.947266 22.6703 4.85202 22.6703 9.66883C22.6703 12.3219 21.4848 14.6987 19.6175 16.297V20.5192C19.6175 21.4432 18.5389 21.947 17.8303 21.354L14.2817 18.384C14.1712 18.3882 14.0603 18.3903 13.9489 18.3903H10.5223C5.70554 18.3903 1.80078 14.4855 1.80078 9.66883Z" fill="#EE731B" stroke="#EE731B" strokeWidth="0.8" />
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5223 2.62199C6.63046 2.62199 3.4755 5.77694 3.4755 9.66883C3.4755 13.5607 6.63046 16.7156 10.5223 16.7156H13.9489C14.1036 16.7156 14.257 16.7107 14.409 16.7008C14.6835 16.6832 14.9613 16.769 15.181 16.9528L17.6572 19.0253C17.7704 19.12 17.9428 19.0395 17.9428 18.892V16.0227C17.9428 15.684 18.0997 15.3732 18.353 15.1702C19.9655 13.8773 20.9957 11.8937 20.9957 9.66883C20.9957 5.77694 17.8407 2.62199 13.9489 2.62199H10.5223ZM1.80078 9.66883C1.80078 4.85202 5.70554 0.947266 10.5223 0.947266H13.9489C18.7656 0.947266 22.6703 4.85202 22.6703 9.66883C22.6703 12.3219 21.4848 14.6987 19.6175 16.297V20.5192C19.6175 21.4432 18.5389 21.947 17.8303 21.354L14.2817 18.384C14.1712 18.3882 14.0603 18.3903 13.9489 18.3903H10.5223C5.70554 18.3903 1.80078 14.4855 1.80078 9.66883Z" fill="#EE731B" stroke="#EE731B" strokeWidth="0.8" />
            </g>
            <defs>
                <clipPath id="clip0_386_21829">
                    <rect width="22.6087" height="21.7391" fill="white" transform="translate(0.695312 0.565186)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const AutomatedMessageIcon = () => {
    return (
        <svg className='max-w-[24px] w-full' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2787_64392)">
                <path d="M12 0C5.37063 0 0 5.37063 0 12C0 18.6294 5.37063 24 12 24C18.6294 24 24 18.6294 24 12C24 5.37063 18.6294 0 12 0ZM13.6504 19.1049C13.6504 19.4685 13.3427 19.7762 12.979 19.7762H11.049C10.6853 19.7762 10.3776 19.4685 10.3776 19.1049V17.0909C10.3776 16.7273 10.6853 16.4196 11.049 16.4196H12.979C13.3427 16.4196 13.6504 16.7273 13.6504 17.0909V19.1049ZM13.6504 14.1538C13.6504 14.5175 13.3427 14.8252 12.979 14.8252H11.049C10.6853 14.8252 10.3776 14.5175 10.3776 14.1538V5.76224C10.3776 5.3986 10.6853 5.09091 11.049 5.09091H12.979C13.3427 5.09091 13.6504 5.3986 13.6504 5.76224V14.1538Z" fill="#3C310C" />
            </g>
            <defs>
                <clipPath id="clip0_2787_64392">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const PurpleChevronRight = () => {
    return (
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2787_64390)">
                <path d="M1.5 11L6.5 6L1.5 1" stroke="#7D4AC3" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2787_64390">
                    <rect width="8" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const DesktopNotificationIcon = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3512 20.3879H6.6447C6.33237 20.4008 6.02057 20.3519 5.72716 20.2441C5.43375 20.1362 5.16449 19.9716 4.93479 19.7596C4.7051 19.5476 4.51948 19.2923 4.38857 19.0084C4.25766 18.7246 4.18402 18.4177 4.17188 18.1053C4.1904 17.1982 4.47771 16.3169 4.99742 15.5732C5.85415 14.2113 6.25768 12.6132 6.15014 11.0079C6.15014 5.77087 8.58492 2.88794 12.998 2.88794C17.411 2.88794 19.8458 5.77087 19.8458 11.0102C19.7382 12.6155 20.1418 14.2136 20.9985 15.5754C21.5178 16.3186 21.8051 17.199 21.8241 18.1053C21.8119 18.4177 21.7383 18.7246 21.6074 19.0084C21.4764 19.2923 21.2908 19.5476 21.0611 19.7596C20.8314 19.9716 20.5622 20.1362 20.2688 20.2441C19.9754 20.3519 19.6636 20.4008 19.3512 20.3879ZM12.998 4.40968C9.46372 4.40968 7.67188 6.63066 7.67188 11.0102C7.7772 12.887 7.30107 14.7507 6.3084 16.347C5.92948 16.857 5.71502 17.4703 5.69361 18.1053C5.69361 18.7315 6.45448 18.8662 6.6447 18.8662H19.3512C19.5399 18.8662 20.3023 18.7315 20.3023 18.1053C20.2811 17.4701 20.0666 16.8564 19.6875 16.3462C18.695 14.7501 18.2189 12.8868 18.324 11.0102C18.324 6.63066 16.5322 4.40968 12.998 4.40968Z" fill="#321A50" stroke="#321A50" />
            <path d="M13.0006 23.8634C12.264 23.8624 11.5579 23.5693 11.0371 23.0484C10.5164 22.5275 10.2235 21.8213 10.2227 21.0847C10.2224 20.911 10.2392 20.7377 10.2729 20.5674C10.2926 20.4694 10.3313 20.3762 10.387 20.2933C10.4427 20.2103 10.5142 20.1391 10.5974 20.0837C10.6806 20.0284 10.7739 19.9899 10.8719 19.9706C10.9699 19.9513 11.0708 19.9515 11.1688 19.9712C11.2668 19.9909 11.3599 20.0297 11.4429 20.0854C11.5259 20.141 11.5971 20.2125 11.6524 20.2957C11.7078 20.3789 11.7462 20.4722 11.7655 20.5702C11.7848 20.6683 11.7846 20.7692 11.7649 20.8671C11.7508 20.9388 11.7439 21.0117 11.7444 21.0847C11.7385 21.2533 11.7667 21.4213 11.8271 21.5787C11.8876 21.7362 11.9791 21.8798 12.0962 22.0011C12.2134 22.1224 12.3538 22.2189 12.509 22.2848C12.6643 22.3507 12.8312 22.3847 12.9998 22.3847C13.1685 22.3847 13.3354 22.3507 13.4906 22.2848C13.6459 22.2189 13.7863 22.1224 13.9034 22.0011C14.0206 21.8798 14.1121 21.7362 14.1726 21.5787C14.233 21.4213 14.2611 21.2533 14.2553 21.0847C14.2558 21.0117 14.2489 20.9388 14.2347 20.8671C14.215 20.7692 14.2148 20.6683 14.2342 20.5702C14.2535 20.4722 14.2919 20.3789 14.3472 20.2957C14.4026 20.2125 14.4738 20.141 14.5568 20.0854C14.6398 20.0297 14.7329 19.9909 14.8309 19.9712C14.9288 19.9515 15.0297 19.9513 15.1278 19.9706C15.2258 19.9899 15.3191 20.0284 15.4023 20.0837C15.4855 20.1391 15.557 20.2103 15.6126 20.2933C15.6683 20.3762 15.7071 20.4694 15.7268 20.5674C15.7605 20.7377 15.7773 20.911 15.777 21.0847C15.7762 21.8211 15.4835 22.527 14.9631 23.0479C14.4426 23.5688 13.7369 23.862 13.0006 23.8634Z" fill="#321A50" stroke="#321A50" strokeWidth="0.8" />
        </svg>
    )
}

export const WelcomeCloseIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.75 4.25L4.25 12.75" stroke="#D6B79F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.25 4.25L12.75 12.75" stroke="#D6B79F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export const BreadCrumbArrow = () => {
    return (
        <svg className="rtl:rotate-180 w-3 h-3 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
        </svg>
    )
}

export const AtTheRateSymbol = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#E2F1FF" />
            <path d="M11.9755 18.7237C10.9937 18.7237 10.1197 18.5898 9.35334 18.3221C8.587 18.0574 7.93916 17.6681 7.4098 17.1541C6.88045 16.6432 6.47727 16.0185 6.20028 15.2798C5.9233 14.5412 5.7848 13.701 5.7848 12.7592C5.7848 11.8298 5.9233 10.9865 6.20028 10.2294C6.48035 9.4723 6.88814 8.82292 7.42365 8.28125C7.95916 7.73651 8.61316 7.31794 9.38565 7.02557C10.1612 6.73319 11.0445 6.587 12.0355 6.587C12.9527 6.587 13.7713 6.72088 14.4915 6.98864C15.2147 7.25639 15.8272 7.63802 16.3288 8.13352C16.8336 8.62595 17.2167 9.21224 17.4783 9.8924C17.743 10.5695 17.8738 11.3189 17.8707 12.1406C17.8738 12.7069 17.8246 13.227 17.723 13.701C17.6214 14.175 17.4614 14.5889 17.2429 14.9428C17.0275 15.2937 16.7443 15.5722 16.3935 15.7784C16.0426 15.9815 15.6179 16.0969 15.1193 16.1246C14.7623 16.1523 14.473 16.1262 14.2514 16.0462C14.0298 15.9661 13.8606 15.8477 13.7436 15.6907C13.6297 15.5307 13.5559 15.3445 13.522 15.1321H13.4666C13.3928 15.3168 13.2481 15.4845 13.0327 15.6353C12.8172 15.783 12.5541 15.8984 12.2433 15.9815C11.9355 16.0616 11.6077 16.0908 11.2599 16.0692C10.8968 16.0477 10.5521 15.9631 10.2259 15.8153C9.9027 15.6676 9.61494 15.4537 9.36257 15.1737C9.11328 14.8936 8.91631 14.5473 8.77166 14.1349C8.63009 13.7225 8.55777 13.2455 8.55469 12.7038C8.55777 12.1683 8.63317 11.7021 8.78089 11.305C8.9317 10.908 9.13021 10.5741 9.37642 10.3033C9.62571 10.0324 9.9027 9.82008 10.2074 9.66619C10.5121 9.51231 10.8183 9.41383 11.1261 9.37074C11.4738 9.31842 11.8031 9.31842 12.114 9.37074C12.4248 9.42306 12.6864 9.50769 12.8988 9.62464C13.1142 9.7416 13.2481 9.86778 13.3004 10.0032H13.3651V9.48615H14.81V13.9918C14.8131 14.2042 14.8608 14.3688 14.9531 14.4858C15.0455 14.6027 15.1701 14.6612 15.3271 14.6612C15.5394 14.6612 15.7164 14.5674 15.858 14.3796C16.0026 14.1919 16.1103 13.9041 16.1811 13.5163C16.255 13.1286 16.2919 12.6346 16.2919 12.0344C16.2919 11.4558 16.215 10.948 16.0611 10.511C15.9103 10.0709 15.6979 9.69697 15.424 9.3892C15.1532 9.07836 14.8377 8.82599 14.4776 8.6321C14.1175 8.43821 13.7267 8.29664 13.305 8.20739C12.8865 8.11813 12.4556 8.07351 12.0124 8.07351C11.2461 8.07351 10.5767 8.19046 10.0043 8.42436C9.43182 8.65518 8.95478 8.97988 8.57315 9.39844C8.19152 9.817 7.9053 10.3079 7.71449 10.8711C7.52675 11.4312 7.43134 12.0421 7.42827 12.7038C7.43134 13.4332 7.53291 14.0795 7.73295 14.6428C7.93608 15.2029 8.23461 15.6738 8.62855 16.0554C9.02249 16.437 9.50876 16.7263 10.0874 16.9233C10.666 17.1203 11.3307 17.2188 12.0817 17.2188C12.4356 17.2188 12.7818 17.1926 13.1204 17.1403C13.4589 17.091 13.7652 17.0295 14.0391 16.9556C14.313 16.8848 14.533 16.8156 14.6992 16.7479L15.1562 18.0866C14.9624 18.1974 14.6992 18.3005 14.3668 18.396C14.0375 18.4944 13.6651 18.5729 13.2496 18.6314C12.8372 18.6929 12.4125 18.7237 11.9755 18.7237ZM11.7631 14.5504C12.1386 14.5504 12.4371 14.4781 12.6587 14.3335C12.8834 14.1888 13.0434 13.9749 13.1388 13.6918C13.2373 13.4055 13.2835 13.0531 13.2773 12.6346C13.2743 12.2653 13.2266 11.9529 13.1342 11.6974C13.045 11.4389 12.8896 11.2435 12.668 11.1112C12.4495 10.9757 12.1448 10.908 11.7539 10.908C11.4123 10.908 11.1214 10.9804 10.8814 11.125C10.6444 11.2696 10.4628 11.4728 10.3366 11.7344C10.2135 11.9929 10.1505 12.2976 10.1474 12.6484C10.1505 12.9747 10.2028 13.284 10.3043 13.5763C10.4059 13.8656 10.5736 14.1011 10.8075 14.2827C11.0414 14.4612 11.36 14.5504 11.7631 14.5504Z" fill="#0084FF" />
        </svg>

    )
}

export function BookGroupClassIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#E368A1" />
      <g clipPath="url(#clip0_1221_4403)">
        <path
          d="M18.0004 13.9817C19.2913 13.9817 20.3378 12.9353 20.3378 11.6444C20.3378 10.3536 19.2913 9.30713 18.0004 9.30713C16.7095 9.30713 15.6631 10.3536 15.6631 11.6444C15.6631 12.9353 16.7095 13.9817 18.0004 13.9817ZM24.8806 20.825L24.8776 20.822C24.4802 20.4204 22.8569 18.6487 22.8445 18.6308C22.7381 18.4753 21.5782 15.3933 21.521 15.275C21.4994 15.2301 21.2287 14.6448 20.5309 14.6448C20.5309 14.6448 15.4606 14.6453 15.4567 14.6462C15.012 14.6561 14.5982 14.934 14.4369 15.3771L13.1758 18.5918L11.1177 20.8275C10.8456 21.1044 10.8216 21.5478 11.0744 21.8535C11.3444 22.18 11.8281 22.2259 12.1546 21.9558C12.9217 21.3214 14.2903 20.2109 14.697 19.6582C14.697 19.6582 15.4202 18.378 15.473 18.2754C15.7156 19.611 15.3993 20.6638 15.1216 21.102C14.7274 21.724 12.2209 22.5595 11.9429 24.0371C11.8333 24.62 12.1926 25.7928 13.7107 25.7928H15.2441C15.0604 25.511 14.888 25.0863 14.9307 24.5781C14.9658 24.1523 15.1479 23.6617 15.6418 23.2592C16.6513 22.4312 18.4065 22.485 20.3387 22.4175C20.4732 22.4128 20.5861 22.5181 20.5908 22.6527C20.5952 22.778 20.5042 22.8844 20.3832 22.9023L20.3813 22.9026C19.6207 23.0121 17.6016 23.3314 17.099 23.5168C16.4382 23.7598 16.0224 24.1305 15.9975 24.6548C15.9689 25.24 16.5456 25.6906 17.4178 25.7928H22.2902C23.8083 25.7928 24.1677 24.62 24.058 24.0371C23.78 22.5596 21.2735 21.724 20.8794 21.102C20.6017 20.6638 20.2852 19.611 20.5279 18.2754C20.7786 18.7636 21.0176 19.1955 21.304 19.6582C21.7019 20.1991 23.1678 21.3947 23.8464 21.9558C24.1464 22.2022 24.5928 22.189 24.8748 21.91C25.176 21.612 25.1786 21.1262 24.8806 20.825Z"
          fill="white"
        />
      </g>
      <g opacity="0.6" clipPath="url(#clip1_1221_4403)">
        <path
          d="M24.3 14.3835C25.1606 14.3835 25.8583 13.6859 25.8583 12.8253C25.8583 11.9647 25.1606 11.2671 24.3 11.2671C23.4394 11.2671 22.7419 11.9647 22.7419 12.8253C22.7419 13.6859 23.4394 14.3835 24.3 14.3835ZM28.8868 18.9457L28.8849 18.9437C28.6199 18.6759 27.5377 17.4948 27.5295 17.4829C27.4585 17.3792 26.6852 15.3246 26.6471 15.2456C26.6327 15.2157 26.4522 14.8256 25.9871 14.8256C25.9871 14.8256 22.6068 14.8259 22.6042 14.8265C22.3078 14.833 22.0319 15.0183 21.9244 15.3137L21.0836 17.4569L21.0837 17.9435C20.9023 18.1281 20.8863 18.4237 21.0548 18.6275C21.2348 18.8452 21.5572 18.8758 21.7749 18.6957C22.2864 18.2728 21.8267 18.5362 22.0977 18.1678C22.0977 18.1678 22.5799 17.3143 22.6151 17.2459C22.7769 18.1364 22.5659 18.8382 22.3808 19.1304C22.118 19.545 22.5167 18.5335 22.3314 19.5185C22.2583 19.9072 21.4505 20.3306 22.4625 20.3306L22.9647 20.6288C23.6211 18.7029 23.0904 21.079 23.1189 20.7402C23.1423 20.4563 22.3984 20.8368 22.7276 20.5684C23.4007 20.0165 24.5707 20.0523 25.8589 20.0074C25.9486 20.0042 26.0239 20.0744 26.027 20.1641C26.0299 20.2476 25.9693 20.3186 25.8886 20.3306L25.8873 20.3307C25.3802 20.4037 24.0342 20.6166 23.6991 20.7402C23.2586 20.9022 23.7157 20.8424 23.6991 21.192C23.6801 21.5821 23.7186 21.8129 24.3001 21.881L27.1599 22.2575C28.172 22.2575 28.4116 21.4757 28.3384 21.087C28.1531 20.1021 26.4821 19.545 26.2194 19.1304C26.0342 18.8382 25.8233 18.1363 25.9851 17.2459C26.1522 17.5714 26.3115 17.8594 26.5024 18.1678C26.7677 18.5284 27.745 19.3255 28.1973 19.6996C28.3973 19.8638 28.695 19.855 28.883 19.669C29.0838 19.4703 29.0855 19.1465 28.8868 18.9457Z"
          fill="white"
        />
      </g>
      <g opacity="0.6" clipPath="url(#clip2_1221_4403)">
        <path
          d="M11.7 14.3835C10.8394 14.3835 10.1417 13.6859 10.1417 12.8253C10.1417 11.9647 10.8394 11.2671 11.7 11.2671C12.5606 11.2671 13.2581 11.9647 13.2581 12.8253C13.2581 13.6859 12.5606 14.3835 11.7 14.3835ZM7.11318 18.9457L7.11515 18.9437C7.38008 18.6759 8.46227 17.4948 8.47054 17.4829C8.54153 17.3792 9.31479 15.3246 9.35291 15.2456C9.36728 15.2157 9.54776 14.8256 10.0129 14.8256C10.0129 14.8256 13.3932 14.8259 13.3958 14.8265C13.6922 14.833 13.9681 15.0183 14.0756 15.3137L14.9164 17.4569L14.9163 17.9435C15.0977 18.1281 15.1137 18.4237 14.9452 18.6275C14.7652 18.8452 14.4428 18.8758 14.2251 18.6957C13.7136 18.2728 14.1733 18.5362 13.9023 18.1678C13.9023 18.1678 13.4201 17.3143 13.3849 17.2459C13.2231 18.1364 13.4341 18.8382 13.6192 19.1304C13.882 19.545 13.4833 18.5335 13.6686 19.5185C13.7417 19.9072 14.5495 20.3306 13.5375 20.3306L13.0353 20.6288C12.3789 18.7029 12.9096 21.079 12.8811 20.7402C12.8577 20.4563 13.6016 20.8368 13.2724 20.5684C12.5993 20.0165 11.4293 20.0523 10.1411 20.0074C10.0514 20.0042 9.97614 20.0744 9.97301 20.1641C9.97007 20.2476 10.0307 20.3186 10.1114 20.3306L10.1127 20.3307C10.6198 20.4037 11.9658 20.6166 12.3009 20.7402C12.7414 20.9022 12.2843 20.8424 12.3009 21.192C12.3199 21.5821 12.2814 21.8129 11.6999 21.881L8.84013 22.2575C7.82801 22.2575 7.58842 21.4757 7.66158 21.087C7.84687 20.1021 9.51791 19.545 9.78062 19.1304C9.96576 18.8382 10.1767 18.1363 10.0149 17.2459C9.84782 17.5714 9.68852 17.8594 9.49757 18.1678C9.2323 18.5284 8.255 19.3255 7.80266 19.6996C7.60265 19.8638 7.305 19.855 7.117 19.669C6.91623 19.4703 6.91449 19.1465 7.11318 18.9457Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1221_4403">
          <rect width="18.9" height="18.9" fill="white" transform="translate(8.55078 8.1001)" />
        </clipPath>
        <clipPath id="clip1_1221_4403">
          <rect width="12.6" height="12.6" fill="white" transform="translate(18 10.4624)" />
        </clipPath>
        <clipPath id="clip2_1221_4403">
          <rect width="12.6" height="12.6" fill="white" transform="matrix(-1 0 0 1 18 10.4624)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BookOneOnOneIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#02ABA3" />
      <g clipPath="url(#clip0_1221_4428)">
        <path
          d="M17.9994 13.9225C19.4747 13.9225 20.6706 12.7265 20.6706 11.2513C20.6706 9.77601 19.4747 8.58008 17.9994 8.58008C16.524 8.58008 15.3282 9.77601 15.3282 11.2513C15.3282 12.7266 16.524 13.9225 17.9994 13.9225ZM25.8624 21.7434L25.859 21.7399C25.4048 21.2809 23.5497 19.2562 23.5355 19.2357C23.4138 19.058 22.0882 15.5358 22.0229 15.4004C21.9982 15.3492 21.6888 14.6803 20.8914 14.6803C20.8914 14.6803 15.0967 14.6809 15.0923 14.6818C14.584 14.6931 14.1111 15.0107 13.9267 15.5172L12.4855 19.1911L10.1334 21.7463C9.82247 22.0627 9.79503 22.5694 10.0839 22.9188C10.3925 23.292 10.9452 23.3444 11.3184 23.0357C12.1951 22.3107 13.7593 21.0415 14.224 20.4099C14.224 20.4099 15.0506 18.9468 15.1108 18.8295C15.3882 20.356 15.0266 21.5592 14.7092 22.06C14.2588 22.7708 11.3942 23.7257 11.0765 25.4143C10.9512 26.0805 11.3619 27.4208 13.0969 27.4208H14.8493C14.6393 27.0988 14.4423 26.6134 14.4911 26.0326C14.5312 25.546 14.7393 24.9853 15.3038 24.5253C16.4576 23.579 18.4634 23.6405 20.6717 23.5634C20.8254 23.558 20.9545 23.6784 20.9598 23.8322C20.9649 23.9753 20.8609 24.097 20.7225 24.1175L20.7204 24.1177C19.8511 24.2429 17.5436 24.6078 16.9692 24.8197C16.2139 25.0975 15.7387 25.521 15.7103 26.1203C15.6776 26.789 16.3367 27.304 17.3336 27.4208H22.9019C24.637 27.4208 25.0477 26.0805 24.9223 25.4143C24.6046 23.7257 21.74 22.7708 21.2896 22.06C20.9723 21.5592 20.6106 20.3559 20.8879 18.8295C21.1745 19.3875 21.4475 19.8811 21.7749 20.4099C22.2296 21.028 23.905 22.3945 24.6804 23.0357C25.0233 23.3173 25.5336 23.3022 25.8558 22.9833C26.2 22.6428 26.203 22.0876 25.8624 21.7434Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1221_4428">
          <rect width="21.6" height="21.6" fill="white" transform="translate(7.19922 7.2002)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

export function GroupClassIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || 'w-[40px] h-[40px]'}`}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3592_356)" />
      <path
        style={{ stroke: 'none' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3107 18.8575C25.4093 18.468 25.4586 18.0786 25.4586 17.6632C25.4586 15.56 24.2507 13.7685 22.5497 12.9636C23.1907 11.925 24.3 11.2499 25.5573 11.2499C27.5541 11.2499 29.1318 12.9896 29.1318 15.0667C29.1318 17.1439 27.5294 18.8575 25.5326 18.8575H25.3107ZM15.9196 18.8573H15.6977C13.7009 18.8573 12.0739 17.1436 12.0739 15.0665C12.0739 12.9893 13.6762 11.2757 15.6731 11.2757C16.9303 11.2757 18.0396 11.9508 18.6806 12.9893C16.9796 13.7683 15.7717 15.5858 15.7717 17.6629C15.7717 18.0784 15.821 18.4678 15.9196 18.8573ZM16.3849 20.104C16.5574 20.4415 16.7793 20.7531 17.0258 21.0387C15.103 21.8955 13.7718 23.8428 13.6978 26.1277H10V23.713C10 21.6358 11.3559 19.8962 13.2048 19.4029C13.9197 19.8703 14.7825 20.1559 15.6946 20.1559C15.9411 20.1559 16.163 20.1299 16.3849 20.104ZM28.0469 19.4029C27.3073 19.8703 26.4692 20.1559 25.5571 20.1559C25.3352 20.1559 25.0887 20.1299 24.8668 20.104C24.6942 20.4415 24.4724 20.7531 24.2259 21.0387C26.1241 21.8955 27.4799 23.8688 27.5539 26.1537H31.2517V23.739C31.2517 21.6358 29.8958 19.8962 28.0469 19.4029ZM26.3182 26.3351C26.3182 24.2579 24.9623 22.4923 23.1134 22.025C22.3739 22.4923 21.5357 22.778 20.6236 22.778C19.7115 22.778 18.8486 22.4923 18.1337 22.025C16.2848 22.5183 14.929 24.2579 14.929 26.3351V28.7498H26.3182V26.3351ZM17.0241 17.6371C17.0241 15.5599 18.6265 13.8463 20.6233 13.8463C22.6201 13.8463 24.2225 15.5599 24.2225 17.6371C24.2225 19.7142 22.6201 21.4279 20.6233 21.4279C18.6512 21.4279 17.0241 19.7402 17.0241 17.6371Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3592_356"
          x1="20"
          y1="60"
          x2="60"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F273A7" />
          <stop offset="1" stopColor="#E368A0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function NotificationsICon() {
  return (
    <svg
      className="cursor-pointer hover:opacity-60"
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8C4 3.6 7.6 0 12 0C16.4 0 20 3.6 20 8V12C20 12.3 20 12.4 20 12.4C20 12.6 20.1 12.8 20.1 13C20.1 13.1 20.2 13.1 20.3 13.4L20.7 14.2C20.9 14.6 21 15 21 15.4C21 16.8 19.8 18 18.4 18H5.6C4.2 18 3 16.8 3 15.4C3 15 3.1 14.6 3.3 14.2L3.7 13.4C3.8 13.1 3.9 13.1 3.9 13C3.9 12.8 4 12.7 4 12.5C4 12.4 4 12.3 4 12.1V8ZM15 19.5H9C9.2 20.9 10.5 22 12 22C13.5 22 14.8 20.9 15 19.5Z"
        fill="#AEAEAE"
      />
    </svg>
  );
}
export function OneOnOneIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || 'w-[40px] h-[40px]'}`}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3592_368)" />
      <circle cx="20" cy="20" r="20" fill="black" fillOpacity="0.2" />
      <path
        style={{ stroke: 'none' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6958 15.1164C18.6993 15.4043 
        18.7018 15.6824 18.6046 15.9312C18.3821 16.1969 18.1382 16.4184 17.849 16.5877C17.3481 16.8809 16.6599 16.9212
        16.1677 17.228C15.1656 17.8523 15.3164 19.1015 15.264 20.0744C15.1849 21.5349 15.3194 22.4143 15.0669 23.9323L11.9268
        26.6178C11.6491 26.4373 11.4996 26.2884 11.3309 26.2188C11.1616 26.1491 10.9727 26.1587 10.6515 26.0756C10.1698 25.7402
        10.0525 25.9352 10.4132 26.2957L10.7702 26.5366C10.871 26.6045 10.8772 26.5751 10.7764 26.6407C10.7764 26.6407 10.4428
        26.748 10.3752 26.715C10.228 26.6431 10.2152 26.4911 10.1301 26.3175C10.1081 26.2729 10.3016 26.1098 10.1608
        25.8997C10.0763 25.7734 9.79058 26.141 9.78806 26.1763C9.78098 26.2743 9.73755 26.4276 9.75801 26.5279C9.77858 26.6282
        9.88074 27.0011 9.88074 27.0011L9.80315 27.0636C9.80315 27.0636 9.44799 27.2021 9.3736 27.2669C9.29932 27.3318 8.98438
        27.4554 8.98438 27.4554C8.71093 27.6412 8.70533 27.7219 8.82235 27.7621C8.82406 27.833 9.02301 27.9638 9.21944
        27.8615C9.18459 28.0578 9.31063 27.9935 9.42845 27.9774C9.89171 27.9135 9.87948 27.7665 10.4282 27.7051C10.6876 27.6761
        11.042 27.6912 11.3927 27.6805C12.1136 27.6586 12.735 27.3687 13.384 27.0386C14.7034 26.3672 15.9609 25.4015 16.1881
        25.0124C16.7125 24.114 16.806 22.1445 16.885 20.6965C16.9377 20.8464 16.9849 20.951 17.0116 20.9946C17.6198 21.9881
        17.9097 23.3906 17.5388 24.5207C17.5329 24.5389 16.249 26.9826 16.2304 26.9985C15.7861 27.191 14.9937 27.167 14.5096
        27.167C13.5047 27.167 9.99055 27.6412 11.4643 29.507C12.3384 30.6136 14.8507 30.8809 16.3118 30.8968C17.8688 30.9138 18.8893 30.8573 19.9262 30.6377C19.969 30.6287 20.0118 30.6188 20.0545 30.6085C20.4674 30.5351 20.8923 30.5251 21.6614 30.5251C22.1031 30.7335 23.5192 30.8483 23.717 30.8927C24.0109 30.9589 24.2885 30.9589 24.4226 31.0494C24.5043 31.1045 24.4771 31.1045 24.5861 31.2012C24.799 31.3899 25.0883 31.0035 24.6117 30.5204C24.3164 30.2213 24.0392 30.1495 23.7333 29.998C24.6685 29.9832 25.5314 30.0239 26.0043 30.0239C26.35 30.0239 27.6374 30.1844 28.6902 29.8632C29.8601 29.5061 30.7219 28.6219 29.2872 27.7137C28.7193 27.3541 27.5958 27.1598 26.9073 27.095C26.001 27.0096 25.1793 27.0256 24.954 27.0304C24.6837 27.0363 24.3867 27.0791 24.099 27.1067C23.4724 27.1671 23.5682 27.201 23.2459 26.6575C23.1141 26.4352 22.9558 26.1609 22.7963 25.8965C22.4111 25.259 22.0176 24.6619 21.9661 24.5273C21.4467 23.1754 21.9906 22.1256 22.4907 20.9092C22.5571 20.7475 22.6191 20.5948 22.6747 20.4122C22.7594 21.8751 22.9783 23.9903 23.3883 25.0281C23.5964 25.5544 25.2888 26.2731 26.6323 26.7739C27.314 27.0279 27.8862 27.2619 28.6071 27.2839C28.9582 27.2947 29.3122 27.2795 29.5718 27.3085C30.1203 27.37 30.1081 27.5167 30.5716 27.5807C30.6894 27.5969 30.8153 27.6611 30.7806 27.4649C30.9769 27.5673 31.1759 27.4364 31.1776 27.3655C31.2947 27.3252 31.2891 27.2447 31.0155 27.0586C31.0155 27.0586 30.7007 26.9351 30.6263 26.8702C30.552 26.8053 30.1968 26.6669 30.1968 26.6669L30.1193 26.6045C30.1193 26.6045 30.2213 26.2316 30.2419 26.1312C30.2626 26.0309 30.2191 25.8777 30.2119 25.7797C30.2093 25.7442 29.9238 25.3767 29.8391 25.503C29.6984 25.7133 29.8918 25.8762 29.8698 25.9209C29.7847 26.0944 29.7719 26.2463 29.6247 26.3182C29.5571 26.3513 29.2236 26.2441 29.2236 26.2441C29.1227 26.1785 29.1289 26.2077 29.2297 26.1399L29.5867 25.899C29.9477 25.5385 29.8301 25.3434 29.3484 25.679C29.0272 25.762 28.8384 25.7523 28.6691 25.8222C28.5004 25.8917 28.3509 26.0406 28.0732 26.2212L24.5096 23.948C24.257 22.4299 24.3916 21.5506 24.3125 20.0902C24.2868 19.6156 24.2648 19.0988 24.1102 18.582C23.8691 17.7763 23.575 17.4038 23.2375 17.1979C23.0897 17.1021 22.9337 17.0392 22.7699 16.9879C21.8512 16.7097 21.4795 16.6922 20.8208 15.8913C20.7448 15.6706 20.7411 15.4285 20.7437 15.1778C21.8454 14.2949 22.3467 11.2733 20.7146 10.2794C19.0151 9.3216 17.0865 10.9378 17.8026 13.4291C18.1271 14.5585 18.4424 14.8538 18.6958 15.1164Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3592_368"
          x1="20"
          y1="60"
          x2="60"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1083F1" />
          <stop offset="0.538323" stopColor="#00C9E7" />
          <stop offset="1" stopColor="#06E1B7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function YogaWithFriendsIcon({ width = 40, height = 40, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      className={className}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3592_376)" />
      <path
        style={{ stroke: 'none' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5792 12.0436C15.5792 13.1717 14.6542 14.0864 13.5136 14.0864C12.3734 14.0864 11.4489 13.1717 11.4489 12.0436C11.4489 10.9151 12.3734 9.99995 13.5136 9.99995C14.6542 9.99995 15.5792 10.9151 15.5792 12.0436ZM28.5479 12.0436C28.5479 13.1717 27.6234 14.0864 26.4828 14.0864C25.3422 14.0864 24.4176 13.1717 24.4176 12.0436C24.4176 10.9151 25.3422 9.99995 26.4828 9.99995C27.6234 9.99995 28.5479 10.9151 28.5479 12.0436ZM20.0015 14.0864C21.1421 14.0864 22.0671 13.1717 22.0671 12.0436C22.0671 10.9151 21.1421 9.99995 20.0015 9.99995C18.8609 9.99995 17.9368 10.9151 17.9368 12.0436C17.9368 13.1717 18.8609 14.0864 20.0015 14.0864ZM32.0934 12.605C32.1953 12.4399 32.2577 12.3388 32.2976 12.3388C32.8403 12.3388 32.3788 16.6237 29.8428 18.8115C30.8719 24.6176 29.5708 29.9998 28.3437 29.9998C28.1428 29.9998 27.9802 29.3285 27.7796 28.5003C27.46 27.1804 27.0439 25.4623 26.2226 25.4293C25.3951 25.3963 24.4237 27.0825 23.6556 28.4159C23.1564 29.2824 22.7431 29.9998 22.5109 29.9998C22.0295 29.9998 21.7935 28.9085 21.5336 27.7061C21.2181 26.2471 20.8673 24.6245 19.9998 24.5897C19.1325 24.6245 18.7817 26.2472 18.4664 27.7062C18.2065 28.9086 17.9707 29.9998 17.4895 29.9998C17.257 29.9998 16.8435 29.2821 16.3442 28.4154C15.576 27.082 14.6048 25.3963 13.7774 25.4293C12.9564 25.4623 12.5402 27.1802 12.2205 28.5001C12.0199 29.3283 11.8572 29.9998 11.6563 29.9998C10.4295 29.9998 9.12803 24.6176 10.1571 18.8115C7.62153 16.6237 7.15966 12.3388 7.70239 12.3388C7.74237 12.3388 7.80489 12.4401 7.90707 12.6057C8.3632 13.3447 9.60961 15.3641 13.1689 15.3667C13.367 15.3332 13.5695 15.3118 13.7774 15.3118C15.0303 15.3118 16.13 15.9505 16.7683 16.9158C17.5442 16.0051 18.702 15.4245 19.9998 15.4245C21.298 15.4245 22.4557 16.0051 23.2316 16.9158C23.8699 15.9505 24.9697 15.3118 26.2226 15.3118C26.4308 15.3118 26.633 15.3332 26.8286 15.3635C30.3912 15.3635 31.6377 13.3435 32.0934 12.605Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3592_376"
          x1="23.6631"
          y1="46.0812"
          x2="45.4022"
          y2="16.4767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F37FF" />
          <stop offset="1" stopColor="#1D06E1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function RightArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 18L15 12L9 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HamBurgerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16" fill="none">
      <rect width="26" height="2" rx="1" fill="black" />
      <rect y="7" width="26" height="2" rx="1" fill="black" />
      <rect y="14" width="26" height="2" rx="1" fill="black" />
    </svg>
  );
}

export function RedDot() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1"
        y="1"
        width="10"
        height="10"
        rx="5"
        fill="#FF2929"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
}

export function NoNotifyIcon() {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 8C4 3.6 7.6 0 12 0C16.4 0 20 3.6 20 8V12C20 12.3 20 12.4 20 12.4C20 12.6 20.1 12.8 20.1 13C20.1 13.1 20.2 13.1 20.3 13.4L20.7 14.2C20.9 14.6 21 15 21 15.4C21 16.8 19.8 18 18.4 18H5.6C4.2 18 3 16.8 3 15.4C3 15 3.1 14.6 3.3 14.2L3.7 13.4C3.8 13.1 3.9 13.1 3.9 13C3.9 12.8 4 12.7 4 12.5C4 12.4 4 12.3 4 12.1V8ZM15 19.5H9C9.2 20.9 10.5 22 12 22C13.5 22 14.8 20.9 15 19.5Z"
        fill="#EE731B"
      />
    </svg>
  );
}

export function SmsIcon() {
  return (
    <svg
      className="cursor-pointer hover:opacity-60"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12C7.4 12 7 12.4 7 13C7 13.6 7.4 14 8 14H13C13.6 14 14 13.6 14 13C14 12.4 13.6 12 13 12H8ZM8 8C7.4 8 7 8.4 7 9C7 9.6 7.4 10 8 10H16C16.6 10 17 9.6 17 9C17 8.4 16.6 8 16 8H8ZM10 2H14C15.4 2 16.4 2 17.3 2.1C18.2 2.2 19 2.3 19.7 2.7C20.8 3.3 21.7 4.2 22.3 5.3C22.7 6 22.8 6.8 22.9 7.7C23 8.5 23 9.6 23 11V19C23 20.6 21.7 22 20 22C19.5 22 19 21.9 18.5 21.6L17.2 20.9C16.6 20.5 16.4 20.4 16.1 20.3C15.8 20.2 15.5 20.1 15.1 20C14.8 20 14.6 20 13.9 20H9.9C8.5 20 7.5 20 6.6 19.9C5.7 19.8 4.9 19.7 4.2 19.3C3.1 18.7 2.2 17.8 1.6 16.7C1.2 16 1.1 15.2 1 14.3C1 13.5 1 12.4 1 11C1 9.6 1 8.6 1.1 7.7C1.1 6.7 1.3 6 1.7 5.3C2.3 4.2 3.2 3.3 4.3 2.7C5 2.3 5.7 2.1 6.6 2.1C7.5 2 8.6 2 10 2Z"
        fill="#AEAEAE"
      />
    </svg>
  );
}

// export function ChevronDown() {
//   return (
//     <svg
//       className="w-5 h-5 zm:ml-2"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//     </svg>
//   );
// }